import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import {
  generateProfessionalHeadshot,
  countPeople,
  detectGender,
  validateImageSafety
} from "./gemini";
import ImageUploader from "./ImageUploader";
import logo from "images/Composz-logo-white-trans.png";
import { ENDPOINTS } from "../constants/endpoints";
import FileManager from "../components/FileManager/FileManager";
import { SPLoader } from "./Spinner.js";

const honorSocieties = [
  { name: "National Honor Society (NHS)", color: "#facc15" }, // Gold
  { name: "National Art Honor Society (NAHS)", color: "#3b82f6" }, // Blue
  { name: "National English Honor Society (NEHS)", color: "#1e3a8a" }, // Dark Blue
  { name: "National Spanish Honor Society", color: "#dc2626" }, // Red
  { name: "National French Honor Society", color: "#2563eb" }, // Royal Blue
  { name: "Mu Alpha Theta (Math)", color: "#60a5fa" }, // Light Blue
  { name: "Science National Honor Society", color: "#10b981" }, // Green
  { name: "Quill and Scroll (Journalism)", color: "#1e40af" }, // Blue/Gold mix usually
  { name: "Tri-M Music Honor Society", color: "#ec4899" }, // Pink
  { name: "Custom / Other", color: "#cbd5e1" }
];

const GenImg = (apikey) => {
  const [hasKey, setHasKey] = useState(true);
  const [mainImage, setMainImage] = useState(null);
  const [maleRef, setMaleRef] = useState(null);
  const [femaleRef, setFemaleRef] = useState(null);
  const [bgRef, setBgRef] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [isSafe, setIsSafe] = useState(true);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [loadingMessage, setLoadingMessage] = useState("");
  const [showJsonOptions, setShowJsonOptions] = useState(false);
  const [sourceImageHeight, setSourceImageHeight] = useState(192);

  const [bgType, setBgType] = useState("none");
  const [bgColor, setBgColor] = useState("#5d4037"); // Default to a classic retro brown
  const [bgBlur, setBgBlur] = useState(false);
  const [bgBlurDepth, setBgBlurDepth] = useState(50);
  const [bgNoise, setBgNoise] = useState(false);
  const [bgNoiseMonochromatic, setBgNoiseMonochromatic] = useState(true);
  const [noiseLevel, setNoiseLevel] = useState(30);
  const [gradientStops, setGradientStops] = useState([
    { id: "1", color: "#1e293b", offset: 0 },
    { id: "2", color: "#475569", offset: 100 }
  ]);
  const [gradientStyle, setGradientStyle] = useState("linear");
  const [gradientAngle, setGradientAngle] = useState(180);

  const [chooseFiles, setChooseFiles] = useState(false);
  const [imageFileList, setImageFileList] = useState({});
  const [isEnhanceModal, setEnhanceModal] = useState(false);

  function showSpinner() {
    document.getElementById("loading-overlay").classList.remove("hidden");
  }

  function hideSpinner() {
    document.getElementById("loading-overlay").classList.add("hidden");
  }

  const toggleChooseFiles = () => {
    setChooseFiles(!chooseFiles);
  };

  const showModal = () => {
    setEnhanceModal(!isEnhanceModal);
  };
  const graduationStyles = [
    "High School",
    "Bachelors",
    "Masters",
    "Doctoral",
    "Faculty",
    "Kindergarten",
    "Mexican"
  ];

  const graduationProps = [
    { value: "none", label: "None" },
    { value: "scroll", label: "Hold Scroll" },
    { value: "holdHat", label: "Hold Hat" },
    { value: "touchHat", label: "Touch Hat" },
    { value: "touchTassel", label: "Touch Tassel" }
  ];

  const [options, setOptions] = useState({
    attireMode: "professional",
    keepDress: false,
    keepEyewear: true,
    keepHair: true,
    facialHair: "default",
    keepMustache: false,
    keepFacialChars: true,
    expression: "original",
    evenLighting: true,
    facingCamera: true,
    isProfileView: false,
    profileDirection: "right",
    profileAngle: 45,
    isCloseup: false,
    closeupIntensity: 50,
    hasHeadroomAdjust: false,
    headroomLevel: 50,
    aspectRatio: "7 inch by 8.05 inch",
    attireType: "suit",
    blazerStyle: "standard",
    attireColor: "#1e293b",
    hasTie: true,
    tieColor: "#991b1b",
    tieStyle: "plain",
    shirtStyle: "solid",
    shirtColor: "#ffffff",
    shirtStripeColor: "#cbd5e1",
    shirtStripeWidth: "thin",
    shirtCheckColor: "#cbd5e1",
    shirtCheckSize: "small",
    blouseStyle: "buttoned-down",
    blouseColor: "#ffffff",
    uniformType: "collar",
    uniformColor: "#0f172a",
    uniformStripeColor: "#ffffff",
    uniformStripeWidth: "thin",
    hasUniformTie: false,
    uniformTieColor: "#991b1b",
    pinaforeShirtColor: "#ffffff",
    pinaforeShirtPattern: "plain",
    pinaforeShirtStripeColor: "#cbd5e1",
    pinaforeShirtStripeWidth: "thin",
    pinaforeShirtSleeves: "short",
    pinaforeSleeveCuff: "plain",
    casualTopType: "tshirt",
    casualTopColor: "#334155",
    casualOuterType: "none",
    casualOuterColor: "#1e293b",
    casualSweaterStyle: "crew-neck",
    blurBgRef: true,
    noBlemishes: false,
    removeHandProps: true,
    removeHandGestures: true,
    subjectBokeh: false,
    subjectBokehDepth: 50,
    isGraduation: false,
    gradStyle: "Bachelors",
    gownColor: "#000000",
    capColor: "#000000",
    hoodColor: "#eab308",
    hasHood: true,
    hasStole: false,
    stoleColor: "#ffffff",
    tasselColor: "#facc15",
    tasselSide: "left",
    tamColor: "#000000",
    sashColor: "#991b1b",
    hasSash: false,
    hasRibbon: false,
    ribbonColor: "#dc2626",
    gradProp: "none",
    gownClosureType: "zipper",
    scrollRibbonColor: "#dc2626",
    hasGradShirt: false,
    gradShirtColor: "#ffffff",
    hasGradTie: false,
    gradTieColor: "#1e293b",
    hasHonorCord: false,
    honorSociety: honorSocieties[0].name,
    honorCordColor: honorSocieties[0].color
  });

  const hasReference = !!mainImage || !!maleRef || !!femaleRef;
  const hasBgRef = !!bgRef;
  const isBgSettingsDisabled = hasBgRef;

  const getAiStudio = () => window.aistudio;

  const generateRandomColor = () => {
    return (
      "#" +
      Math.floor(Math.random() * 16777215)
        .toString(16)
        .padStart(6, "0")
    );
  };

  const [imgCredits, setimgCredits] = useState(0);

  const getimgcreditsfromDB = () => {
    let imgcredits_uri = ENDPOINTS.imgcredits.index.uri;
    let noRecords;

    (async () => {
      noRecords = await fetch(imgcredits_uri, {
        method: "GET",
        headers: { "content-type": "application/json" }
      })
        .then((response) => response.json())
        .then((data) => {
          setimgCredits(data.imgcredits);
        });
    })();
  };

  const setimgcreditsfromDB = (imgcredits) => {
    let imgcredits_uri = ENDPOINTS.imgcredits.index.uri;
    let noRecords;

    imgcredits_uri = imgcredits_uri + "?imgcredits=" + imgcredits;

    (async () => {
      noRecords = await fetch(imgcredits_uri, {
        method: "GET",
        headers: { "content-type": "application/json" }
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.errors) {
            alert(data.errors);
            return;
          }
          setimgCredits(data.imgcredits);
        });
    })();
  };

  const handleRandomizeGradient = () => {
    const stopCount = 2 + Math.floor(Math.random() * 2);
    const newStops = [];
    for (let i = 0; i < stopCount; i++) {
      newStops.push({
        id: Math.random().toString(36).substr(2, 9),
        color: generateRandomColor(),
        offset: Math.round((i / (stopCount - 1)) * 100)
      });
    }
    setGradientStops(newStops);
    setGradientAngle(Math.floor(Math.random() * 360));
  };

  const handleReverseGradient = () => {
    setGradientStops((prev) => {
      return [...prev]
        .map((stop) => ({
          ...stop,
          offset: 100 - stop.offset
        }))
        .sort((a, b) => a.offset - b.offset);
    });
  };

  const addGradientStop = () => {
    if (gradientStops.length >= 5) return;
    const newStop = {
      id: Math.random().toString(36).substr(2, 9),
      color: generateRandomColor(),
      offset: 50
    };
    setGradientStops(
      [...gradientStops, newStop].sort((a, b) => a.offset - b.offset)
    );
  };

  const removeGradientStop = (id) => {
    if (gradientStops.length <= 2) return;
    setGradientStops(gradientStops.filter((s) => s.id !== id));
  };

  const updateGradientStop = (id, updates) => {
    setGradientStops(
      gradientStops.map((s) => (s.id === id ? { ...s, ...updates } : s))
    );
  };

  useEffect(() => {
    const checkKey = async () => {
      try {
        const studio = getAiStudio();
        if (studio && typeof studio.hasSelectedApiKey === "function") {
          const selected = await studio.hasSelectedApiKey();
          setHasKey(selected);
        }
      } catch (e) {
        console.error(e);
      }
    };
    checkKey();
  }, []);

  useEffect(() => {
    let interval;
    if (isGenerating) {
      const msgs = [
        "Detecting person...",
        "Analyzing gender & features...",
        "Matching attire reference...",
        "Rendering lighting...",
        "Finalizing portrait..."
      ];
      let idx = 0;
      setLoadingMessage(msgs[0]);
      interval = window.setInterval(() => {
        idx = (idx + 1) % msgs.length;
        setLoadingMessage(msgs[idx]);
      }, 5000);
    }
    return () => clearInterval(interval);
  }, [isGenerating]);

  useEffect(() => {
    let interval;
    if (!isSafe) {
      const msgs = [
        "Detecting person...",
        "Analyzing gender & features...",
        "Checking attire reference...",
        "Validating safety checks..."
      ];
      let idx = 0;
      setLoadingMessage(msgs[0]);
      interval = window.setInterval(() => {
        idx = (idx + 1) % msgs.length;
        setLoadingMessage(msgs[idx]);
      }, 5000);
    }
    return () => clearInterval(interval);
  }, [!isSafe]);

  const handleSelectKey = async () => {
    try {
      const studio = getAiStudio();
      if (studio) {
        await studio.openSelectKey();
        setHasKey(true);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleOptionChange = (key, value) => {
    setOptions((prev) => {
      const newOptions = { ...prev, [key]: value };
      return newOptions;
    });
  };

  const setAttireMode = (mode) => {
    setOptions((prev) => ({
      ...prev,
      attireMode: mode,
      isGraduation: mode === "graduation",
      keepDress: mode === "keepOriginal"
    }));
  };

  const validateAndSetImage = async (apikey, img, setter, label) => {
    showSpinner();
    setIsSafe(false);
    setter(img);
    setError(null);
    setIsSafe(false);
    try {
      const safety = await validateImageSafety(img, apikey);
      if (!safety.safe) {
        setter(null);
        setError(`${label} rejected: ${safety.reason}`);
        alert(`${label} rejected: ${safety.reason}`);
        setIsSafe(true);
      } else setIsSafe(true);
      hideSpinner();
    } catch (err) {
      console.error(err);
      setIsSafe(true);
      hideSpinner();
      // Fallback in case of API error during immediate check
    }
  };

  const currentConfig = {
    background: {
      type: bgType,
      color: bgColor,
      gradientStops,
      gradientStyle,
      gradientAngle,
      blur: bgBlur,
      blurDepth: bgBlurDepth,
      noise: bgNoise,
      noiseLevel: noiseLevel,
      noiseMonochromatic: bgNoiseMonochromatic
    },
    options,
    references: {
      hasMaleRef: !!maleRef,
      hasFemaleRef: !!femaleRef,
      hasBgRef: !!bgRef
    }
  };

  const handleBatchGenerate = async () => {
    if (!Object.keys(imageFileList).length === 0) {
      setError("Choose your files first.");
      alert("Choose your files first.");
      return;
    }

    if (maleRef) {
      Object.keys(maleRef).map((key) => {
        // console.log(`Key => ${key}`);
      });
      // return;
    }

    let fileNamesArray = Object.keys(imageFileList);
    // console.log(`fileNamesArray => ${fileNamesArray}`);
    // console.log(`configJson => ${JSON.stringify(currentConfig, null, 2)}`);
    // return;

    let configJson = JSON.stringify(currentConfig, null, 2);
    let formData = new FormData();
    if (maleRef) formData.append("maleRef", maleRef.file);
    if (femaleRef) formData.append("femaleRef", femaleRef.file);
    if (bgRef) formData.append("bgRef", bgRef.file);
    formData.append("fileNamesArray", fileNamesArray);
    formData.append("configJson", configJson);
    formData.append("batchCount", Object.keys(imageFileList).length);

    // let $ajax = $.ajax({
    //   url: template_url,
    //   type: "POST",
    //   method: "POST",
    //   data: formData,
    //   processData: false,
    //   contentType: false,
    // });
    // $ajax.done(function () {
    //   alert("Successfully, Uploaded image");
    // });
    // $ajax.fail(function () {
    //   //alert("Save of image failed!");
    // });

    let url = "/api/batch_enhance";
    let ajaxCall = fetch(url, {
      // headers: {
      //   Accept: "application/json",
      //   "Content-Type": "application/json",
      // },
      method: "POST",
      body: formData
    });
    return ajaxCall
      .then((response) => response.json())
      .then((response) => {
        // console.log(`response.data => ${response.data}`);
        // console.log(`response => ${JSON.stringify(response)}`);
        if (response.status === 205)
          setimgCredits(imgCredits - Object.keys(imageFileList).length);
        alert(response.data);
        window.location.href = "/products";
      });
  };

  const handleGenerate = async () => {
    showSpinner();

    if (!mainImage) {
      setError("Upload your photo first.");
      alert("Upload your photo first.");
      hideSpinner();
      return;
    }

    if (imgCredits < 1) {
      alert(
        "No Image Credits Available. Please purchase more before proceeding!"
      );
      hideSpinner();
      return;
    }

    setimgcreditsfromDB(1);

    setIsGenerating(true);
    setError(null);
    setResult(null);
    // setLoadingMessage("Screening images for safety...");

    try {
      // Final Safety Validation for all images before generation
      const imagesToValidate = [
        { img: mainImage, label: "Identity Photo" },
        { img: maleRef, label: "Male Reference" },
        { img: femaleRef, label: "Female Reference" },
        { img: bgRef, label: "Background Reference" }
      ].filter((item) => item.img !== null);

      // for (const item of imagesToValidate) {
      //   if (item.img) {
      //     const safety = await validateImageSafety(item.img);
      //     if (!safety.safe) {
      //       setIsGenerating(false);
      //       setError(`${item.label} rejected: ${safety.reason}`);
      //       alert(`${item.label} rejected: ${safety.reason}`);
      //       alert("Please note: Image credit not REFUNDED!!");
      //       return;
      //     }
      //   }
      // }

      setLoadingMessage("Checking image content...");
      const count = await countPeople(mainImage, apikey);
      if (count === -1 || count === -2) {
        setIsGenerating(false);
        setimgcreditsfromDB(-1);
        alert("MODEL not available. Try Again.");
        hideSpinner();
        return;
      }
      if (count > 1) {
        setIsGenerating(false);
        // setError("Multiple people detected. Please upload an image containing ONLY one person.");
        alert(
          "Multiple people detected. Please upload an image containing ONLY one person."
        );
        setimgcreditsfromDB(-1);
        hideSpinner();
        return;
      }
      if (count === 0) {
        setIsGenerating(false);
        // setError("No people detected. Please upload a clear photo of a person.");
        alert("No people detected. Please upload a clear photo of a person.");
        setimgcreditsfromDB(-1);
        hideSpinner();
        return;
      }

      setLoadingMessage("Detecting gender...");
      const gender = await detectGender(mainImage, apikey);

      if (gender === "NA") {
        setIsGenerating(false);
        setimgcreditsfromDB(-1);
        alert("MODEL not available. Try Again.");
        hideSpinner();
        return;
      }

      if (gender === "unknown") {
        setIsGenerating(false);
        setimgcreditsfromDB(-1);
        hideSpinner();
        return;
      }

      setLoadingMessage("Generating professional portrait...");

      const response = await generateProfessionalHeadshot(
        apikey,
        mainImage,
        currentConfig.background,
        options,
        gender,
        maleRef || undefined,
        femaleRef || undefined,
        bgRef || undefined
      );
      setResult({
        imageUrl: response.imageUrl,
        usage: response.usage,
        fileExtension: response.fileExtension,
        timestamp: Date.now()
      });
      hideSpinner();
    } catch (err) {
      if (err.message === "API_KEY_RESET_REQUIRED") setHasKey(false);
      setError(err.message || "An error occurred.");
      alert(err.message || "An error occurred.");
      setimgcreditsfromDB(-1);
      hideSpinner();
    } finally {
      setIsGenerating(false);
      hideSpinner();
    }
  };

  const handleDownload = () => {
    if (!result) return;
    const link = document.createElement("a");
    link.href = result.imageUrl;
    link.download = `headshot-${Date.now()}.${result.fileExtension}`;
    link.click();
  };

  const handleCreateCss = () => {
    let compiledCss = "";
    // Tailwind CDN usually injects a style block. We search for all styles.
    const styleElements = document.querySelectorAll("style");
    styleElements.forEach((style) => {
      // Check if it's the one generated by tailwind or our custom ones
      compiledCss += style.innerHTML + "\n\n";
    });

    const blob = new Blob([compiledCss], { type: "text/css" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "compiled-styles.css";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const previewGradient = () => {
    const sortedStops = [...gradientStops].sort((a, b) => a.offset - b.offset);
    const stopString = sortedStops
      .map((s) => `${s.color} ${s.offset}%`)
      .join(", ");
    return gradientStyle === "linear"
      ? `linear-gradient(${gradientAngle}deg, ${stopString})`
      : `radial-gradient(circle, ${stopString})`;
  };

  const renderBackgroundPreview = () => {
    if (bgType === "none") return null;

    let style = {};
    let content = null;

    if (bgType === "gradient") {
      style = { background: previewGradient() };
    } else if (bgType === "clean") {
      style = { backgroundColor: bgColor };
    } else if (bgType === "retro") {
      // Create a classic retro texture effect with CSS
      style = {
        backgroundColor: bgColor,
        backgroundImage: `radial-gradient(circle at center, transparent 0%, rgba(0,0,0,0.4) 100%), 
                          url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
        backgroundBlendMode: "overlay",
        backgroundSize: "cover",
        opacity: 0.9
      };
      content = (
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <span className="text-[10px] font-bold text-white/20 uppercase tracking-[0.2em]">
            Retro Canvas Texture
          </span>
        </div>
      );
    } else if (bgType === "office") {
      style = {
        background:
          'linear-gradient(rgba(30,41,59,0.8), rgba(30,41,59,0.8)), url("https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80&w=800") center/cover no-repeat'
      };
    }

    return (
      // <div className="relative w-full h-32 rounded-2xl overflow-hidden border border-slate-800 shadow-inner mb-6 animate-in fade-in zoom-in-95 duration-300">
      <div
        className="relative w-full rounded-2xl overflow-hidden border border-slate-800 shadow-inner mb-6 animate-in fade-in zoom-in-95 duration-300"
        style={{ height: "125px" }}
      >
        <div
          className="absolute inset-0 transition-all duration-500"
          style={style}
        >
          {content}
        </div>
        <div className="absolute bottom-2 left-2 px-2 py-0.5 bg-black/40 backdrop-blur-md rounded-md text-[10px] font-bold text-white/70 uppercase tracking-widest border border-white/10">
          Studio Backdrop Preview
        </div>
      </div>
    );
  };

  if (!hasKey) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-slate-950 text-white">
        <div className="max-w-md w-full glass p-8 rounded-3xl text-center">
          <h1 className="text-3xl font-bold mb-4">Professional Studio</h1>
          <p className="text-slate-400 mb-8 text-sm">
            Select an API key to start generating high-end headshots.
          </p>
          <button
            onClick={handleSelectKey}
            className="w-full bg-indigo-600 hover:bg-indigo-500 font-bold py-3 px-6 rounded-xl shadow-lg"
          >
            Select API Key
          </button>
        </div>
      </div>
    );
  }

  getimgcreditsfromDB();

  return (
    <div className="min-h-screen pb-20 bg-slate-950 text-slate-200">
      <header className="glass sticky top-0 z-10 px-6 py-4 flex justify-between items-center">
        <div className="flex items-center space-x-2">
          {/* <div className="w-8 h-8 bg-indigo-600 rounded-lg flex items-center justify-center text-white font-bold"> */}
          {/* P */}
          <div className="flex items-center justify-center  font-bold">
            <img height="35px" src={logo} />
          </div>
          <span className="font-bold text-amber-500 text-lg">
            ProHeadshot AI
          </span>
        </div>
        {/* <button
          onClick={handleSelectKey}
          className="text-xs px-3 py-1.5 bg-slate-800 rounded-full hover:bg-slate-700"
        >
          Change Key
        </button> */}
        <span>Image Credits Available: {imgCredits}</span>
        <button
          onClick={toggleChooseFiles}
          className="text-xs px-3 py-1.5 bg-slate-800 rounded-full hover:bg-slate-700"
        >
          Choose Images from Uploaded Files
        </button>

        <div style={{ display: "none" }}>
          {chooseFiles && (
            <FileManager
              setChooseFiles={setChooseFiles}
              fetchImageFileList={setImageFileList}
              flg={true}
            />
          )}
        </div>
        <button
          onClick={() => {
            // console.log(Object.keys(imageFileList).length);
            // Object.keys(imageFileList).map((file_path) => {
            //   console.log(file_path);
            // });
            if (Object.keys(imageFileList).length === 0) {
              alert("No files chosen!");
            } else showModal();
          }}
        >
          Show chosen files
        </button>
      </header>

      <main className="max-w-7xl mx-auto px-6 pt-10 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-8 space-y-8">
          <section className="space-y-4">
            <div className="flex items-center justify-between">
              <h2 className="text-lg font-bold flex items-center space-x-2">
                <span className="text-indigo-400">01</span>
                <span>Source Image</span>
              </h2>
            </div>
            <ImageUploader
              label="Identity Photo"
              description="Clear face photo (Single person ONLY)"
              image={mainImage}
              onUpload={(img) =>
                validateAndSetImage(apikey, img, setMainImage, "Identity Photo")
              }
              onClear={() => {
                if (
                  document
                    .getElementById("loading-overlay")
                    .classList.contains("hidden")
                )
                  setMainImage(null);
              }}
              required
              height={sourceImageHeight}
            />
            <div className="flex flex-col items-center space-y-1 py-2">
              <label className="text-[10px] font-bold text-slate-500 uppercase">
                Zoom Image
              </label>
              <input
                type="range"
                min="150"
                max="500"
                value={sourceImageHeight}
                onChange={(e) => setSourceImageHeight(parseInt(e.target.value))}
                // className="w-64 h-1 bg-slate-800 rounded-lg appearance-none cursor-pointer accent-indigo-500"
                className="h-1 bg-slate-800 rounded-lg appearance-none cursor-pointer accent-indigo-500"
                style={{ width: "30%" }}
              />
            </div>
            {/* <br></br> */}
            <p className="flex flex-col items-center space-y-2 py-2 text-[10px] text-amber-500 font-semibold mt-1 uppercase tracking-tight">
              Images will be rejected if decent images wearing decent attires
              are not provided.
            </p>
          </section>

          <section className="space-y-6">
            <h2 className="text-lg font-bold flex items-center space-x-2">
              <span className="text-indigo-400">02</span>
              <span>Refinement Controls</span>
            </h2>
            <div className="glass p-6 rounded-3xl space-y-8">
              {/* GLOBAL STYLE & REFERENCES */}
              <div className="space-y-6">
                <h4 className="text-[10px] font-bold text-indigo-400 uppercase tracking-widest border-b border-indigo-500/20 pb-2">
                  Style References
                </h4>
                <p className="text-[10px] text-slate-500 italic">
                  Upload attire references. The engine detects gender and
                  prioritizes matching reference.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <ImageUploader
                    label="Male Style Reference"
                    description="Auto-applied for Male subjects"
                    image={maleRef}
                    onUpload={(img) =>
                      validateAndSetImage(
                        apikey,
                        img,
                        setMaleRef,
                        "Male Reference"
                      )
                    }
                    onClear={() => {
                      if (
                        document
                          .getElementById("loading-overlay")
                          .classList.contains("hidden")
                      )
                        setMaleRef(null);
                    }}
                  />
                  <ImageUploader
                    label="Female Style Reference"
                    description="Auto-applied for Female subjects"
                    image={femaleRef}
                    onUpload={(img) =>
                      validateAndSetImage(
                        apikey,
                        img,
                        setFemaleRef,
                        "Female Reference"
                      )
                    }
                    onClear={() => {
                      if (
                        document
                          .getElementById("loading-overlay")
                          .classList.contains("hidden")
                      )
                        setFemaleRef(null);
                    }}
                  />
                </div>
                <p className="flex flex-col items-center space-y-2 py-2 text-[10px] text-amber-500 font-semibold mt-1 uppercase tracking-tight">
                  Images will be rejected if decent images wearing decent
                  attires are not provided.
                </p>
              </div>

              {/* ATTIRE MODE SELECTOR */}
              <div className="mt-8 pt-8 border-t border-slate-800/50 space-y-6">
                <div className="flex items-center justify-between">
                  <h3 className="text-sm font-bold text-slate-400 uppercase tracking-wider">
                    Attire Mode
                  </h3>
                  {hasReference && (
                    <span className="text-[10px] text-indigo-400 font-bold uppercase">
                      Reference Priority Enabled
                    </span>
                  )}
                </div>

                <div className="grid grid-cols-2 md:grid-cols-5 gap-2">
                  {[
                    { mode: "professional", label: "Professional" },
                    { mode: "graduation", label: "Graduation" },
                    { mode: "uniform", label: "Uniform" },
                    { mode: "casual", label: "Casual" },
                    { mode: "keepOriginal", label: "Keep Original" }
                  ].map(({ mode, label }) => (
                    <button
                      key={mode}
                      onClick={() => setAttireMode(mode)}
                      className={`py-3 px-2 rounded-xl text-xs font-bold border transition-all ${
                        options.attireMode === mode
                          ? "bg-indigo-600 border-indigo-500 text-white shadow-lg"
                          : "bg-slate-900 border-slate-800 text-slate-500 hover:bg-slate-800"
                      }`}
                    >
                      {label.toUpperCase()}
                    </button>
                  ))}
                </div>

                {/* MODE SPECIFIC OPTIONS PANELS */}
                <div className="mt-8 min-h-[100px]">
                  {/* PROFESSIONAL MODE */}
                  {options.attireMode === "professional" && (
                    <div className="space-y-8 animate-in fade-in slide-in-from-top-2 border-t border-slate-800/50 pt-8">
                      <div className="bg-slate-900/40 p-6 rounded-3xl border border-slate-800 max-w-4xl mx-auto space-y-10">
                        <div className="border-b border-slate-800 pb-4">
                          <h4 className="text-xs font-bold text-slate-400 uppercase tracking-widest">
                            Outerwear Customization
                          </h4>
                        </div>

                        {/* SUIT / BLAZER SECTION */}
                        <div className="space-y-8">
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                            <div className="space-y-4">
                              <label className="text-xs font-bold text-slate-500 uppercase block tracking-widest">
                                Attire Type
                              </label>
                              <div className="flex flex-col space-y-3">
                                <div className="flex bg-slate-950 rounded-xl p-1 border border-slate-800">
                                  <button
                                    onClick={() =>
                                      handleOptionChange("attireType", "suit")
                                    }
                                    className={`flex-1 py-2 rounded-lg text-[10px] font-bold transition-all ${
                                      options.attireType === "suit"
                                        ? "bg-indigo-600 text-white shadow-md"
                                        : "text-slate-500 hover:text-slate-300"
                                    }`}
                                  >
                                    BUSINESS SUIT
                                  </button>
                                  <button
                                    onClick={() =>
                                      handleOptionChange("attireType", "blazer")
                                    }
                                    className={`flex-1 py-2 rounded-lg text-[10px] font-bold transition-all ${
                                      options.attireType === "blazer"
                                        ? "bg-indigo-600 text-white shadow-md"
                                        : "text-slate-500 hover:text-slate-300"
                                    }`}
                                  >
                                    PROFESSIONAL BLAZER
                                  </button>
                                </div>

                                {options.attireType === "blazer" && (
                                  <div className="flex bg-slate-950/50 rounded-lg p-1 border border-slate-800/50 animate-in fade-in slide-in-from-top-1">
                                    <button
                                      onClick={() =>
                                        handleOptionChange(
                                          "blazerStyle",
                                          "standard"
                                        )
                                      }
                                      className={`flex-1 py-1.5 rounded text-[9px] font-bold transition-all ${
                                        options.blazerStyle === "standard"
                                          ? "bg-slate-700 text-white"
                                          : "text-slate-500 hover:text-slate-400"
                                      }`}
                                    >
                                      STANDARD
                                    </button>
                                    <button
                                      onClick={() =>
                                        handleOptionChange(
                                          "blazerStyle",
                                          "english"
                                        )
                                      }
                                      className={`flex-1 py-1.5 rounded text-[9px] font-bold transition-all ${
                                        options.blazerStyle === "english"
                                          ? "bg-slate-700 text-white"
                                          : "text-slate-500 hover:text-slate-400"
                                      }`}
                                    >
                                      ENGLISH
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="space-y-4">
                              <label className="text-xs font-bold text-slate-500 block uppercase tracking-widest">
                                Jacket Color
                              </label>
                              <div className="flex items-center space-x-3">
                                <input
                                  type="color"
                                  value={options.attireColor}
                                  onChange={(e) =>
                                    handleOptionChange(
                                      "attireColor",
                                      e.target.value
                                    )
                                  }
                                  // className="w-10 h-10 rounded-lg cursor-pointer bg-transparent border-none p-0"
                                  className="rounded-lg cursor-pointer bg-transparent border-none p-0"
                                  style={{ width: "60%", height: "35px" }}
                                />
                                <div
                                  // className="flex-1 h-10 rounded-lg border border-slate-700 flex items-center px-3 bg-slate-900 font-mono text-xs uppercase"
                                  className="flex-1 rounded-lg border border-slate-700 flex items-center px-3 bg-slate-900 font-mono text-xs uppercase"
                                  style={{
                                    color: options.attireColor,
                                    height: "35px"
                                  }}
                                >
                                  {options.attireColor}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="border-b border-slate-800 pb-4">
                          <h4 className="text-xs font-bold text-slate-400 uppercase tracking-widest">
                            Inner Layer Customization
                          </h4>
                          <p className="text-[10px] text-amber-500 mt-1">
                            Configure options for both Female (Blouse) and Male
                            (Shirt/Tie) subjects.
                          </p>
                        </div>

                        {/* INNER LAYERS: BLOUSE OR SHIRT/TIE */}
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
                          <div className="space-y-6 p-6 bg-indigo-950/20 border border-indigo-500/20 rounded-3xl animate-in fade-in">
                            <div className="space-y-1">
                              <label className="text-xs font-bold text-indigo-400 uppercase tracking-widest block">
                                Blouse (Female Subject)
                              </label>
                            </div>

                            <div className="space-y-4">
                              <label className="text-[10px] font-bold text-slate-500 uppercase tracking-widest block">
                                Blouse Style
                              </label>
                              <div className="grid grid-cols-2 gap-2">
                                {[
                                  {
                                    val: "buttoned-down",
                                    label: "Buttoned-down"
                                  },
                                  { val: "tie-neck", label: "Tie-neck" },
                                  { val: "peplum", label: "Peplum" },
                                  {
                                    val: "short-sleeve",
                                    label: "Short Sleeve"
                                  },
                                  { val: "sleeveless", label: "Sleeveless" },
                                  { val: "shirt-tie", label: "Shirt & Tie" }
                                ].map((s) => (
                                  <button
                                    key={s.val}
                                    onClick={() =>
                                      handleOptionChange("blouseStyle", s.val)
                                    }
                                    className={`py-2 px-1 rounded-lg text-[9px] font-bold border transition-all ${
                                      options.blouseStyle === s.val
                                        ? "bg-indigo-600 border-indigo-500 text-white"
                                        : "bg-slate-900 border-slate-800 text-slate-500 hover:text-slate-300"
                                    }`}
                                  >
                                    {s.label.toUpperCase()}
                                  </button>
                                ))}
                              </div>
                            </div>

                            {options.blouseStyle !== "shirt-tie" ? (
                              <div className="space-y-4 animate-in fade-in">
                                <label className="text-[10px] font-bold text-slate-500 uppercase tracking-widest block">
                                  Blouse Color
                                </label>
                                <div className="flex items-center space-x-3">
                                  <input
                                    type="color"
                                    value={options.blouseColor}
                                    onChange={(e) =>
                                      handleOptionChange(
                                        "blouseColor",
                                        e.target.value
                                      )
                                    }
                                    // className="w-10 h-10 rounded-lg cursor-pointer bg-transparent border-2 border-slate-800 p-1"
                                    className="rounded-lg cursor-pointer bg-transparent border-2 border-slate-800 p-1"
                                    style={{ height: "30px", width: "60%" }}
                                  />
                                  <div
                                    // className="flex-1 h-10 rounded-lg border border-slate-800 flex items-center px-3 bg-slate-950 font-mono text-xs uppercase"
                                    className="flex-1 rounded-lg border border-slate-800 flex items-center px-3 bg-slate-950 font-mono text-xs uppercase"
                                    style={{
                                      color: options.blouseColor,
                                      height: "30px"
                                    }}
                                  >
                                    {options.blouseColor}
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className="space-y-6 pt-2 animate-in slide-in-from-top-2">
                                <div className="grid grid-cols-2 gap-4">
                                  <div className="space-y-2">
                                    <label className="text-[9px] font-bold text-slate-500 uppercase block">
                                      Shirt Color
                                    </label>
                                    <input
                                      type="color"
                                      value={options.shirtColor}
                                      onChange={(e) =>
                                        handleOptionChange(
                                          "shirtColor",
                                          e.target.value
                                        )
                                      }
                                      // className="w-full h-8 rounded-lg cursor-pointer bg-slate-900 border-slate-700"
                                      className="w-full rounded-lg cursor-pointer bg-slate-900 border-slate-700"
                                      style={{ height: "30px" }}
                                    />
                                  </div>
                                  <div className="space-y-2">
                                    <label className="text-[9px] font-bold text-slate-500 uppercase block">
                                      Tie Color
                                    </label>
                                    <input
                                      type="color"
                                      value={options.tieColor}
                                      onChange={(e) =>
                                        handleOptionChange(
                                          "tieColor",
                                          e.target.value
                                        )
                                      }
                                      // className="w-full h-8 rounded-lg cursor-pointer bg-slate-900 border-slate-700"
                                      className="w-full rounded-lg cursor-pointer bg-slate-900 border-slate-700"
                                      style={{ height: "30px" }}
                                    />
                                  </div>
                                </div>
                                <div className="space-y-2">
                                  <label className="text-[9px] font-bold text-slate-500 uppercase block">
                                    Tie Pattern
                                  </label>
                                  <select
                                    value={options.tieStyle}
                                    onChange={(e) =>
                                      handleOptionChange(
                                        "tieStyle",
                                        e.target.value
                                      )
                                    }
                                    // className="w-full h-8 bg-slate-900 border border-slate-800 rounded-lg px-2 text-[9px] outline-none font-bold uppercase"
                                    className="w-full bg-slate-900 border border-slate-800 rounded-lg px-2 text-[9px] outline-none font-bold uppercase"
                                    style={{ height: "30px" }}
                                  >
                                    {[
                                      "plain",
                                      "stripes",
                                      "dots",
                                      "stars",
                                      "textured",
                                      "random"
                                    ].map((s) => (
                                      <option key={s} value={s}>
                                        {s}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            )}
                          </div>

                          {/* SHIRT STYLE SECTION (MALE/GENERAL) */}
                          <div className="space-y-6 p-6 bg-slate-950/40 rounded-3xl border border-slate-800 animate-in fade-in">
                            <label className="text-xs font-bold text-slate-400 uppercase block tracking-widest">
                              Shirt & Tie (Male Subject)
                            </label>

                            <div className="grid grid-cols-3 gap-3">
                              {[
                                { value: "solid", label: "SOLID" },
                                { value: "striped", label: "STRIPED" },
                                { value: "gingham", label: "GINGHAM" }
                              ].map((s) => (
                                <button
                                  key={s.value}
                                  onClick={() =>
                                    handleOptionChange("shirtStyle", s.value)
                                  }
                                  className={`py-2 rounded-lg text-[10px] font-bold border transition-all ${
                                    options.shirtStyle === s.value
                                      ? "bg-indigo-600 border-indigo-500 text-white shadow-lg"
                                      : "bg-slate-950 border-slate-800 text-slate-500 hover:bg-slate-800"
                                  }`}
                                >
                                  {s.label}
                                </button>
                              ))}
                            </div>

                            <div className="space-y-6">
                              {options.shirtStyle === "solid" && (
                                <div className="space-y-4 animate-in fade-in">
                                  <label className="text-[10px] font-bold text-slate-500 uppercase tracking-widest block">
                                    Shirt Color
                                  </label>
                                  <div className="flex items-center space-x-4">
                                    <input
                                      type="color"
                                      value={options.shirtColor}
                                      onChange={(e) =>
                                        handleOptionChange(
                                          "shirtColor",
                                          e.target.value
                                        )
                                      }
                                      // className="w-10 h-10 rounded-xl cursor-pointer bg-transparent border-2 border-slate-700 p-1"
                                      className=" rounded-xl cursor-pointer bg-transparent border-2 border-slate-700 p-1"
                                      style={{ width: "60%", height: "30px" }}
                                    />
                                    <span
                                      className="text-xs font-mono text-indigo-400 uppercase font-bold"
                                      style={{ color: options.shirtColor }}
                                    >
                                      {options.shirtColor}
                                    </span>
                                  </div>
                                </div>
                              )}

                              {options.shirtStyle === "striped" && (
                                <div className="space-y-4 animate-in fade-in">
                                  <div className="grid grid-cols-2 gap-4">
                                    <div className="space-y-2">
                                      <label className="text-[9px] font-bold text-slate-500 uppercase block">
                                        Base Color
                                      </label>
                                      <input
                                        type="color"
                                        value={options.shirtColor}
                                        onChange={(e) =>
                                          handleOptionChange(
                                            "shirtColor",
                                            e.target.value
                                          )
                                        }
                                        // className="w-full h-8 rounded-lg cursor-pointer bg-slate-900 border-slate-700"
                                        className="w-full rounded-lg cursor-pointer bg-slate-900 border-slate-700"
                                        style={{ height: "30px" }}
                                      />
                                    </div>
                                    <div className="space-y-2">
                                      <label className="text-[9px] font-bold text-slate-500 uppercase block">
                                        Stripe Color
                                      </label>
                                      <input
                                        type="color"
                                        value={options.shirtStripeColor}
                                        onChange={(e) =>
                                          handleOptionChange(
                                            "shirtStripeColor",
                                            e.target.value
                                          )
                                        }
                                        // className="w-full h-8 rounded-lg cursor-pointer bg-slate-900 border-slate-700"
                                        className="w-full rounded-lg cursor-pointer bg-slate-900 border-slate-700"
                                        style={{ height: "30px" }}
                                      />
                                    </div>
                                  </div>
                                  <div className="flex bg-slate-950 rounded-lg p-1 border border-slate-800">
                                    {["thin", "medium", "thick"].map((w) => (
                                      <button
                                        key={w}
                                        onClick={() =>
                                          handleOptionChange(
                                            "shirtStripeWidth",
                                            w
                                          )
                                        }
                                        className={`flex-1 py-1 rounded text-[8px] font-bold transition-all ${
                                          options.shirtStripeWidth === w
                                            ? "bg-slate-700 text-white"
                                            : "text-slate-500"
                                        }`}
                                        style={{ fontSize: "x-small" }}
                                      >
                                        {w.toUpperCase()}
                                      </button>
                                    ))}
                                  </div>
                                </div>
                              )}

                              {options.shirtStyle === "gingham" && (
                                <div className="space-y-4 animate-in fade-in">
                                  <div className="grid grid-cols-2 gap-4">
                                    <div className="space-y-2">
                                      <label className="text-[9px] font-bold text-slate-500 uppercase block">
                                        Base Color
                                      </label>
                                      <input
                                        type="color"
                                        value={options.shirtColor}
                                        onChange={(e) =>
                                          handleOptionChange(
                                            "shirtColor",
                                            e.target.value
                                          )
                                        }
                                        // className="w-full h-8 rounded-lg cursor-pointer bg-slate-900 border-slate-700"
                                        className="w-full rounded-lg cursor-pointer bg-slate-900 border-slate-700"
                                        style={{ height: "30px" }}
                                      />
                                    </div>
                                    <div className="space-y-2">
                                      <label className="text-[9px] font-bold text-slate-500 uppercase block">
                                        Check Color
                                      </label>
                                      <input
                                        type="color"
                                        value={options.shirtCheckColor}
                                        onChange={(e) =>
                                          handleOptionChange(
                                            "shirtCheckColor",
                                            e.target.value
                                          )
                                        }
                                        // className="w-full h-8 rounded-lg cursor-pointer bg-slate-900 border-slate-700"
                                        className="w-full rounded-lg cursor-pointer bg-slate-900 border-slate-700"
                                        style={{ height: "30px" }}
                                      />
                                    </div>
                                  </div>
                                  <div className="flex bg-slate-950 rounded-lg p-1 border border-slate-800">
                                    {["small", "medium", "large"].map((s) => (
                                      <button
                                        key={s}
                                        onClick={() =>
                                          handleOptionChange(
                                            "shirtCheckSize",
                                            s
                                          )
                                        }
                                        className={`flex-1 py-1 rounded text-[8px] font-bold transition-all ${
                                          options.shirtCheckSize === s
                                            ? "bg-slate-700 text-white"
                                            : "text-slate-500"
                                        }`}
                                        style={{ fontSize: "x-small" }}
                                      >
                                        {s.toUpperCase()}
                                      </button>
                                    ))}
                                  </div>
                                </div>
                              )}

                              {/* TIE SECTION */}
                              <div className="space-y-4 pt-4 border-t border-slate-800/50">
                                <div className="flex items-center justify-between">
                                  <span className="text-[10px] font-bold text-slate-500 uppercase tracking-widest">
                                    Include Tie
                                  </span>
                                  <input
                                    type="checkbox"
                                    checked={options.hasTie}
                                    onChange={(e) =>
                                      handleOptionChange(
                                        "hasTie",
                                        e.target.checked
                                      )
                                    }
                                    // className="w-4 h-4 rounded text-indigo-500 bg-slate-800 border-slate-700"
                                    className="w-4 rounded text-indigo-500 bg-slate-800 border-slate-700"
                                    style={{
                                      height: "15px",
                                      marginBottom: "4px"
                                    }}
                                  />
                                </div>

                                {options.hasTie && (
                                  <div className="grid grid-cols-2 gap-4 animate-in fade-in slide-in-from-top-1">
                                    <div className="space-y-2">
                                      <label className="text-[9px] font-bold text-slate-500 uppercase block">
                                        Tie Color
                                      </label>
                                      <input
                                        type="color"
                                        value={options.tieColor}
                                        onChange={(e) =>
                                          handleOptionChange(
                                            "tieColor",
                                            e.target.value
                                          )
                                        }
                                        // className="w-full h-8 rounded-lg bg-slate-900 border border-slate-800"
                                        className="w-full rounded-lg bg-slate-900 border border-slate-800"
                                        style={{ height: "30px" }}
                                      />
                                    </div>
                                    <div className="space-y-2">
                                      <label className="text-[9px] font-bold text-slate-500 uppercase block">
                                        Tie Pattern
                                      </label>
                                      <select
                                        value={options.tieStyle}
                                        onChange={(e) =>
                                          handleOptionChange(
                                            "tieStyle",
                                            e.target.value
                                          )
                                        }
                                        // className="w-full h-8 bg-slate-900 border border-slate-800 rounded-lg px-2 text-[9px] outline-none font-bold uppercase"
                                        className="w-full bg-slate-900 border border-slate-800 rounded-lg px-2 text-[9px] outline-none font-bold uppercase"
                                        style={{ height: "30px" }}
                                      >
                                        {[
                                          "plain",
                                          "stripes",
                                          "dots",
                                          "stars",
                                          "textured",
                                          "random"
                                        ].map((s) => (
                                          <option key={s} value={s}>
                                            {s}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* GRADUATION MODE */}
                  {options.attireMode === "graduation" && (
                    <div className="space-y-8 animate-in fade-in slide-in-from-top-2 border-t border-slate-800/50 pt-8">
                      <div className="flex flex-col space-y-6">
                        <div className="flex flex-col space-y-4">
                          <div className="flex items-center justify-between">
                            <label className="text-[10px] font-bold text-slate-500 uppercase">
                              Academic Level
                            </label>
                            <div className="flex flex-wrap items-center justify-end gap-x-4 gap-y-2">
                              <label className="flex items-center space-x-2 cursor-pointer group">
                                <input
                                  type="checkbox"
                                  checked={options.hasHood}
                                  onChange={(e) =>
                                    handleOptionChange(
                                      "hasHood",
                                      e.target.checked
                                    )
                                  }
                                  // className="w-3.5 h-3.5 rounded text-indigo-500 border-slate-700 bg-slate-800"
                                  className="w-4 rounded text-indigo-500 border-slate-700 bg-slate-800"
                                  style={{
                                    height: "15px",
                                    marginBottom: "4px"
                                  }}
                                />
                                <span className="text-[10px] font-bold text-slate-400 group-hover:text-slate-200 uppercase">
                                  Include Hood
                                </span>
                              </label>
                              <label
                                className="flex items-center space-x-2 cursor-pointer group"
                                style={{
                                  marginRight: "10px",
                                  marginLeft: "10px"
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={options.hasStole}
                                  onChange={(e) =>
                                    handleOptionChange(
                                      "hasStole",
                                      e.target.checked
                                    )
                                  }
                                  // className="w-3.5 h-3.5 rounded text-indigo-500 border-slate-700 bg-slate-800"
                                  className="w-4 rounded text-indigo-500 border-slate-700 bg-slate-800"
                                  style={{
                                    height: "15px",
                                    marginBottom: "4px"
                                  }}
                                />
                                <span className="text-[10px] font-bold text-slate-400 group-hover:text-slate-200 uppercase">
                                  Include Stole
                                </span>
                              </label>
                            </div>
                          </div>
                          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
                            {graduationStyles.map((style) => (
                              <button
                                key={style}
                                onClick={() =>
                                  handleOptionChange("gradStyle", style)
                                }
                                className={`py-2 px-3 rounded-xl text-[10px] font-bold border transition-all ${
                                  options.gradStyle === style
                                    ? "bg-indigo-600 border-indigo-500 text-white shadow-lg"
                                    : "bg-slate-900 border-slate-800 text-slate-500 hover:bg-slate-800"
                                }`}
                              >
                                {style.toUpperCase()}
                              </button>
                            ))}
                          </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div className="flex flex-col space-y-4 bg-slate-900/40 p-4 rounded-2xl border border-slate-800">
                            <div className="flex items-center justify-between">
                              <label className="text-[10px] font-bold text-slate-500 uppercase tracking-widest">
                                Gown Closure Type
                              </label>
                              <div
                                className="flex bg-slate-950 rounded-lg p-1 border border-slate-800 w-48"
                                style={{ width: "50%" }}
                              >
                                <button
                                  onClick={() =>
                                    handleOptionChange(
                                      "gownClosureType",
                                      "zipper"
                                    )
                                  }
                                  className={`flex-1 py-1.5 rounded-md text-[9px] font-bold transition-all ${
                                    options.gownClosureType === "zipper"
                                      ? "bg-indigo-600 text-white shadow-sm"
                                      : "text-slate-500 hover:text-slate-300"
                                  }`}
                                >
                                  ZIPPER
                                </button>
                                <button
                                  onClick={() =>
                                    handleOptionChange(
                                      "gownClosureType",
                                      "tie-knot"
                                    )
                                  }
                                  className={`flex-1 py-1.5 rounded-md text-[9px] font-bold transition-all ${
                                    options.gownClosureType === "tie-knot"
                                      ? "bg-indigo-600 text-white shadow-sm"
                                      : "text-slate-500 hover:text-slate-300"
                                  }`}
                                >
                                  TIE-KNOT
                                </button>
                              </div>
                            </div>
                            <p
                              className="text-[8px] text-slate-500 italic uppercase"
                              style={{ color: "#f59e0b", fontSize: "x-small" }}
                            >
                              Zipper is modern; Tie-Knot is more traditional
                              academic styling.
                            </p>
                          </div>

                          <div className="flex flex-col space-y-4 bg-slate-900/40 p-4 rounded-2xl border border-slate-800">
                            <div className="flex items-center justify-between">
                              <label className="text-[10px] font-bold text-slate-500 uppercase tracking-widest">
                                Tassel Side
                              </label>
                              <div
                                className="flex bg-slate-950 rounded-lg p-1 border border-slate-800 w-48"
                                style={{ width: "50%" }}
                              >
                                <button
                                  onClick={() =>
                                    handleOptionChange("tasselSide", "left")
                                  }
                                  className={`flex-1 py-1.5 rounded-md text-[9px] font-bold transition-all ${
                                    options.tasselSide === "left"
                                      ? "bg-indigo-600 text-white shadow-sm"
                                      : "text-slate-500 hover:text-slate-300"
                                  }`}
                                >
                                  LEFT
                                </button>
                                <button
                                  onClick={() =>
                                    handleOptionChange("tasselSide", "right")
                                  }
                                  className={`flex-1 py-1.5 rounded-md text-[9px] font-bold transition-all ${
                                    options.tasselSide === "right"
                                      ? "bg-indigo-600 text-white shadow-sm"
                                      : "text-slate-500 hover:text-slate-300"
                                  }`}
                                >
                                  RIGHT
                                </button>
                              </div>
                            </div>
                            <p
                              className="text-[8px] text-slate-500 italic uppercase"
                              style={{ color: "#f59e0b", fontSize: "x-small" }}
                            >
                              Left side is the default position for graduation.
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* <div className="grid grid-cols-2 md:grid-cols-7 gap-6 p-6 bg-slate-950/50 rounded-2xl border border-slate-800"> */}
                      <div className="grid grid-cols-7 md:grid-cols-7 gap-6 p-6 bg-slate-950/50 rounded-2xl border border-slate-800">
                        <div className="space-y-3">
                          <label className="text-[10px] font-bold text-slate-500 uppercase block">
                            Gown
                          </label>
                          <input
                            type="color"
                            value={options.gownColor}
                            onChange={(e) =>
                              handleOptionChange("gownColor", e.target.value)
                            }
                            // className="w-8 h-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                            className="w-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                            style={{ height: "35px" }}
                          />
                        </div>
                        <div className="space-y-3">
                          <label className="text-[10px] font-bold text-slate-500 uppercase block">
                            Cap/Tam
                          </label>
                          <input
                            type="color"
                            value={options.capColor}
                            onChange={(e) =>
                              handleOptionChange("capColor", e.target.value)
                            }
                            // className="w-8 h-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                            className="w-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                            style={{ height: "35px" }}
                          />
                        </div>
                        <div className="space-y-3">
                          <label className="text-[10px] font-bold text-slate-500 uppercase block">
                            Tassel
                          </label>
                          <input
                            type="color"
                            value={options.tasselColor}
                            onChange={(e) =>
                              handleOptionChange("tasselColor", e.target.value)
                            }
                            // className="w-8 h-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                            className="w-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                            style={{ height: "35px" }}
                          />
                        </div>
                        <div
                          className={`space-y-3 transition-opacity ${
                            !options.hasHood ? "opacity-30" : "opacity-100"
                          }`}
                          style={{
                            opacity: `${!options.hasHood ? "0.3" : "1.0"}`
                          }}
                        >
                          <label className="text-[10px] font-bold text-slate-500 uppercase block">
                            Hood
                          </label>
                          <input
                            type="color"
                            disabled={!options.hasHood}
                            value={options.hoodColor}
                            onChange={(e) =>
                              handleOptionChange("hoodColor", e.target.value)
                            }
                            // className="w-8 h-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                            className="w-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                            style={{ height: "35px" }}
                          />
                        </div>
                        <div
                          className={`space-y-3 transition-opacity ${
                            !options.hasStole ? "opacity-30" : "opacity-100"
                          }`}
                          style={{
                            opacity: `${!options.hasStole ? "0.3" : "1.0"}`
                          }}
                        >
                          <label className="text-[10px] font-bold text-slate-500 uppercase block">
                            Stole
                          </label>
                          <input
                            type="color"
                            disabled={!options.hasStole}
                            value={options.stoleColor}
                            onChange={(e) =>
                              handleOptionChange("stoleColor", e.target.value)
                            }
                            // className="w-8 h-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                            className="w-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                            style={{ height: "35px" }}
                          />
                        </div>
                        <div
                          className={`space-y-3 transition-opacity ${
                            !options.hasGradShirt ? "opacity-30" : "opacity-100"
                          }`}
                          style={{
                            opacity: `${!options.hasGradShirt ? "0.3" : "1.0"}`
                          }}
                        >
                          <label className="text-[10px] font-bold text-slate-500 uppercase block">
                            Shirt
                          </label>
                          <input
                            type="color"
                            disabled={!options.hasGradShirt}
                            value={options.gradShirtColor}
                            onChange={(e) =>
                              handleOptionChange(
                                "gradShirtColor",
                                e.target.value
                              )
                            }
                            // className="w-8 h-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                            className="w-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                            style={{ height: "35px" }}
                          />
                        </div>
                        <div
                          className={`space-y-3 transition-opacity ${
                            !(options.hasGradShirt && options.hasGradTie)
                              ? "opacity-30"
                              : "opacity-100"
                          }`}
                          style={{
                            opacity: `${
                              !(options.hasGradShirt && options.hasGradTie)
                                ? "0.3"
                                : "1.0"
                            }`
                          }}
                        >
                          <label className="text-[10px] font-bold text-slate-500 uppercase block">
                            Tie
                          </label>
                          <input
                            type="color"
                            disabled={
                              !(options.hasGradShirt && options.hasGradTie)
                            }
                            value={options.gradTieColor}
                            onChange={(e) =>
                              handleOptionChange("gradTieColor", e.target.value)
                            }
                            // className="w-8 h-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                            className="w-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                            style={{ height: "35px" }}
                          />
                        </div>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="bg-slate-900/40 p-4 rounded-2xl border border-slate-800 space-y-4">
                          <h4 className="text-[10px] font-bold text-slate-500 uppercase">
                            Regalia Accessories
                          </h4>
                          <div className="flex flex-col space-y-4">
                            <label className="flex items-center space-x-2 cursor-pointer group">
                              <input
                                type="checkbox"
                                checked={options.hasGradShirt}
                                onChange={(e) =>
                                  handleOptionChange(
                                    "hasGradShirt",
                                    e.target.checked
                                  )
                                }
                                // className="w-3.5 h-3.5 rounded text-indigo-500 border-slate-700 bg-slate-800"
                                className="w-4 rounded text-indigo-500 border-slate-700 bg-slate-800"
                                style={{ height: "15px", marginBottom: "4px" }}
                              />
                              <span className="text-[10px] font-bold text-slate-400 group-hover:text-slate-200 uppercase">
                                Button-Down Shirt
                              </span>
                            </label>
                            <label
                              className={`flex items-center space-x-2 cursor-pointer group transition-opacity ${
                                !options.hasGradShirt
                                  ? "opacity-30 pointer-events-none"
                                  : "opacity-100"
                              }`}
                              style={{
                                opacity: `${
                                  !options.hasGradShirt ? "0.3" : "1.0"
                                }`
                              }}
                            >
                              <input
                                type="checkbox"
                                disabled={!options.hasGradShirt}
                                checked={options.hasGradTie}
                                onChange={(e) =>
                                  handleOptionChange(
                                    "hasGradTie",
                                    e.target.checked
                                  )
                                }
                                // className="w-3.5 h-3.5 rounded text-indigo-500 border-slate-700 bg-slate-800"
                                className="w-4 rounded text-indigo-500 border-slate-700 bg-slate-800"
                                style={{ height: "15px", marginBottom: "4px" }}
                              />
                              <span className="text-[10px] font-bold text-slate-400 group-hover:text-slate-200 uppercase">
                                Add Tie
                              </span>
                            </label>
                            <div className="h-px bg-slate-800 my-1" />
                            <div className="space-y-2">
                              <label className="flex items-center space-x-3 cursor-pointer group">
                                <input
                                  type="checkbox"
                                  checked={options.hasSash}
                                  onChange={(e) =>
                                    handleOptionChange(
                                      "hasSash",
                                      e.target.checked
                                    )
                                  }
                                  // className="w-4 h-4 rounded text-indigo-500"
                                  className="w-4 rounded text-indigo-500"
                                  style={{
                                    height: "15px",
                                    marginBottom: "4px"
                                  }}
                                />
                                <span className="text-xs">Academic Sash</span>
                              </label>
                              {options.hasSash && (
                                <div className="pl-7 animate-in slide-in-from-top-1">
                                  <div className="flex items-center space-x-3 bg-slate-950/50 p-2 rounded-xl border border-slate-800">
                                    <input
                                      type="color"
                                      value={
                                        options.hasSash
                                          ? options.sashColor
                                          : "#000000"
                                      }
                                      onChange={(e) =>
                                        handleOptionChange(
                                          "sashColor",
                                          e.target.value
                                        )
                                      }
                                      // className="w-6 h-6 rounded-lg cursor-pointer"
                                      className="w-4 rounded-lg cursor-pointer"
                                      style={{ height: "30px", width: "30%" }}
                                    />
                                    <span
                                      className="text-[10px] font-mono text-indigo-400 font-bold uppercase"
                                      style={{ fontSize: "15px" }}
                                    >
                                      {options.sashColor}
                                    </span>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="space-y-2">
                              <label className="flex items-center space-x-3 cursor-pointer group">
                                <input
                                  type="checkbox"
                                  checked={options.hasRibbon}
                                  onChange={(e) =>
                                    handleOptionChange(
                                      "hasRibbon",
                                      e.target.checked
                                    )
                                  }
                                  // className="w-4 h-4 rounded text-indigo-500"
                                  className="w-4 rounded text-indigo-500"
                                  style={{
                                    height: "15px",
                                    marginBottom: "4px"
                                  }}
                                />
                                <span className="text-xs">
                                  Ceremonial Ribbon
                                </span>
                              </label>
                              {options.hasRibbon && (
                                <div className="pl-7 animate-in slide-in-from-top-1">
                                  <div className="flex items-center space-x-3 bg-slate-950/50 p-2 rounded-xl border border-slate-800">
                                    <input
                                      type="color"
                                      value={options.ribbonColor}
                                      onChange={(e) =>
                                        handleOptionChange(
                                          "ribbonColor",
                                          e.target.value
                                        )
                                      }
                                      // className="w-6 h-6 rounded-lg cursor-pointer"
                                      className="w-4 rounded-lg cursor-pointer"
                                      style={{ height: "30px", width: "30%" }}
                                    />
                                    <span
                                      className="text-[10px] font-mono text-indigo-400 font-bold uppercase"
                                      style={{ fontSize: "15px" }}
                                    >
                                      {options.ribbonColor}
                                    </span>
                                  </div>
                                </div>
                              )}
                            </div>

                            <div className="h-px bg-slate-800 my-1" />
                            <div className="space-y-3">
                              <label className="flex items-center space-x-3 cursor-pointer group">
                                <input
                                  type="checkbox"
                                  checked={options.hasHonorCord}
                                  onChange={(e) =>
                                    handleOptionChange(
                                      "hasHonorCord",
                                      e.target.checked
                                    )
                                  }
                                  // className="w-4 h-4 rounded text-indigo-500"
                                  className="w-4 rounded text-indigo-500"
                                  style={{
                                    height: "15px",
                                    marginBottom: "4px"
                                  }}
                                />
                                <span className="text-xs font-bold text-slate-300">
                                  Honor Cords
                                </span>
                              </label>
                              {options.hasHonorCord && (
                                <div className="pl-7 space-y-4 animate-in slide-in-from-top-1">
                                  <div className="space-y-2">
                                    <label className="text-[9px] font-bold text-slate-500 uppercase tracking-widest block">
                                      Select Honor Society
                                    </label>
                                    <select
                                      value={options.honorSociety}
                                      onChange={(e) => {
                                        const soc = honorSocieties.find(
                                          (s) => s.name === e.target.value
                                        );
                                        if (soc) {
                                          handleOptionChange(
                                            "honorSociety",
                                            soc.name
                                          );
                                          handleOptionChange(
                                            "honorCordColor",
                                            soc.color
                                          );
                                        }
                                      }}
                                      className="w-full h-8 bg-slate-950 border border-slate-800 rounded-lg px-2 text-[10px] outline-none font-bold text-indigo-400"
                                    >
                                      {honorSocieties.map((s) => (
                                        <option key={s.name} value={s.name}>
                                          {s.name.toUpperCase()}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  <div className="flex items-center space-x-3 bg-slate-950/50 p-2 rounded-xl border border-slate-800">
                                    <input
                                      type="color"
                                      value={options.honorCordColor}
                                      onChange={(e) =>
                                        handleOptionChange(
                                          "honorCordColor",
                                          e.target.value
                                        )
                                      }
                                      className="w-6 h-6 rounded-lg cursor-pointer bg-transparent"
                                    />
                                    <div className="flex flex-col">
                                      <span className="text-[9px] font-mono text-indigo-300 uppercase font-bold">
                                        {options.honorCordColor}
                                      </span>
                                      <span className="text-[8px] text-slate-600 uppercase">
                                        Cord Color
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="bg-slate-900/40 p-4 rounded-2xl border border-slate-800 space-y-4">
                          <h4 className="text-[10px] font-bold text-slate-500 uppercase">
                            Portrait Prop
                          </h4>
                          <div className="grid grid-cols-2 gap-2 pb-2 border-b border-slate-800/50 mb-2">
                            {graduationProps.map((prop) => (
                              <button
                                key={prop.value}
                                onClick={() =>
                                  handleOptionChange("gradProp", prop.value)
                                }
                                className={`py-1.5 px-2 rounded-lg text-[9px] font-bold border transition-all ${
                                  options.gradProp === prop.value
                                    ? "bg-indigo-600 text-white"
                                    : "bg-slate-950 border-slate-800 text-slate-500"
                                }`}
                              >
                                {prop.label.toUpperCase()}
                              </button>
                            ))}
                          </div>
                          {options.gradProp === "scroll" && (
                            <div className="space-y-3 animate-in fade-in slide-in-from-top-1">
                              <label className="text-[10px] font-bold text-slate-500 uppercase block">
                                Scroll Ribbon Color
                              </label>
                              <div className="flex items-center space-x-3 bg-slate-950/50 p-2 rounded-xl border border-slate-800">
                                <input
                                  type="color"
                                  value={options.scrollRibbonColor}
                                  onChange={(e) =>
                                    handleOptionChange(
                                      "scrollRibbonColor",
                                      e.target.value
                                    )
                                  }
                                  // className="w-6 h-6 rounded-lg cursor-pointer bg-transparent border-none p-0"
                                  className="w-4 rounded-lg cursor-pointer bg-transparent border-none p-0"
                                  style={{ height: "30px", width: "60%" }}
                                />
                                <div className="flex flex-col">
                                  <span
                                    className="text-[10px] font-mono text-indigo-400 font-bold uppercase"
                                    style={{ fontSize: "12px" }}
                                  >
                                    {options.scrollRibbonColor}
                                  </span>
                                  <span
                                    className="text-[8px] text-slate-600 font-bold uppercase"
                                    style={{
                                      color: "#f59e0b",
                                      fontSize: "9px"
                                    }}
                                  >
                                    Ribbon tied to scroll
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* UNIFORM MODE */}
                  {options.attireMode === "uniform" && (
                    <div className="space-y-8 animate-in fade-in slide-in-from-top-2 border-t border-slate-800/50 pt-8">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                        <div className="space-y-4">
                          <label className="text-xs font-bold text-slate-500 uppercase tracking-widest block">
                            Uniform Type
                          </label>
                          <div className="grid grid-cols-2 gap-3">
                            {[
                              { type: "collar", label: "Collar Shirt" },
                              { type: "checkered", label: "Checkered" },
                              { type: "striped", label: "Striped" },
                              { type: "polo", label: "Polo T-Shirt" },
                              { type: "blouse", label: "Blouse (Girls)" },
                              { type: "pinafore", label: "Pinafore (Girls)" }
                            ].map(({ type, label }) => (
                              <button
                                key={type}
                                onClick={() =>
                                  handleOptionChange("uniformType", type)
                                }
                                className={`py-2 px-3 rounded-xl text-[10px] font-bold border transition-all ${
                                  options.uniformType === type
                                    ? "bg-indigo-600 border-indigo-500 text-white"
                                    : "bg-slate-900 border-slate-800 text-slate-500 hover:bg-slate-800"
                                }`}
                              >
                                {label.toUpperCase()}
                              </button>
                            ))}
                          </div>

                          {(options.uniformType === "pinafore" ||
                            options.uniformType === "blouse") && (
                            <div className="bg-indigo-950/20 border border-indigo-500/20 p-3 rounded-xl animate-in slide-in-from-top-1">
                              {/* <p className="text-[9px] text-indigo-400 font-bold uppercase tracking-tight flex items-start space-x-2"> */}
                              <p className="text-[9px] text-amber-500 font-bold uppercase tracking-tight flex items-start space-x-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  // className="h-3.5 w-3.5 mt-0.5"
                                  // className="h-4 w-4 mt-0.5"
                                  className="w-4 mt-0.5"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                                <span>
                                  Restricted to Female subjects. Males will
                                  default to professional attire.
                                </span>
                              </p>
                            </div>
                          )}

                          <div className="pt-4 space-y-4">
                            <label className="text-xs font-bold text-slate-500 uppercase tracking-widest block">
                              {options.uniformType === "pinafore"
                                ? "Pinafore Dress Color"
                                : "Base Color"}
                            </label>
                            <div className="flex items-center space-x-4 bg-slate-900/50 p-3 rounded-2xl border border-slate-800">
                              <input
                                type="color"
                                value={options.uniformColor}
                                onChange={(e) =>
                                  handleOptionChange(
                                    "uniformColor",
                                    e.target.value
                                  )
                                }
                                // className="w-10 h-10 rounded-lg cursor-pointer bg-transparent border-none p-0"
                                className="rounded-lg cursor-pointer bg-transparent border-none p-0"
                                style={{ height: "30px", width: "60%" }}
                              />
                              <div
                                // className="flex-1 h-10 rounded-lg border border-slate-700 flex items-center px-3 bg-slate-900 font-mono text-xs uppercase"
                                className="flex-1 rounded-lg border border-slate-700 flex items-center px-3 bg-slate-900 font-mono text-xs uppercase"
                                style={{
                                  color: options.uniformColor,
                                  height: "30px"
                                }}
                              >
                                {options.uniformColor}
                              </div>
                            </div>
                          </div>

                          {options.uniformType === "striped" && (
                            <div className="pt-2 space-y-4 animate-in slide-in-from-top-2">
                              <div className="space-y-4 bg-slate-900/40 p-4 rounded-2xl border border-slate-800">
                                <div className="space-y-2">
                                  <label className="text-xs font-bold text-slate-500 uppercase tracking-widest block">
                                    Stripe Color
                                  </label>
                                  <div className="flex items-center space-x-4">
                                    <input
                                      type="color"
                                      value={options.uniformStripeColor}
                                      onChange={(e) =>
                                        handleOptionChange(
                                          "uniformStripeColor",
                                          e.target.value
                                        )
                                      }
                                      // className="w-10 h-10 rounded-lg cursor-pointer bg-transparent border-none p-0"
                                      className="rounded-lg cursor-pointer bg-transparent border-none p-0"
                                      style={{ height: "30px", width: "60%" }}
                                    />
                                    {/* <div className="flex flex-col"> */}
                                    <div>
                                      <span
                                        className="text-xs font-mono text-indigo-400 font-bold"
                                        style={{
                                          height: "30px",
                                          fontSize: "15px"
                                        }}
                                      >
                                        {options.uniformStripeColor.toUpperCase()}
                                      </span>
                                      {/* <span
                                        className="text-[9px] text-slate-600 font-bold uppercase"
                                        style={{ fontSize: "12px" }}
                                      >
                                        Stripe Color
                                      </span> */}
                                    </div>
                                  </div>
                                </div>
                                <div className="space-y-2 border-t border-slate-800 pt-3">
                                  <label className="text-xs font-bold text-slate-500 uppercase tracking-widest block">
                                    Stripe Thickness
                                  </label>
                                  <div className="flex bg-slate-950 rounded-xl p-1 space-x-1">
                                    {["thin", "medium", "thick"].map((w) => (
                                      <button
                                        key={w}
                                        onClick={() =>
                                          handleOptionChange(
                                            "uniformStripeWidth",
                                            w
                                          )
                                        }
                                        className={`flex-1 py-1.5 rounded-lg text-[9px] font-bold transition-all ${
                                          options.uniformStripeWidth === w
                                            ? "bg-indigo-600 text-white shadow-md"
                                            : "text-slate-600 hover:text-slate-400"
                                        }`}
                                      >
                                        {w.toUpperCase()}
                                      </button>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {options.uniformType !== "pinafore" && (
                            <div className="space-y-3 pt-4">
                              <div className="flex items-center justify-between">
                                <label className="text-xs font-bold text-slate-500 uppercase tracking-widest">
                                  Add Uniform Tie
                                </label>
                                <input
                                  type="checkbox"
                                  checked={options.hasUniformTie}
                                  onChange={(e) =>
                                    handleOptionChange(
                                      "hasUniformTie",
                                      e.target.checked
                                    )
                                  }
                                  // className="w-4 h-4 rounded text-indigo-500"
                                  className="w-4 rounded text-indigo-500"
                                  style={{
                                    height: "15px",
                                    marginBottom: "4px"
                                  }}
                                />
                              </div>
                              {options.hasUniformTie && (
                                <div className="flex items-center space-x-4 bg-slate-900/50 p-3 rounded-2xl border border-slate-800 animate-in fade-in slide-in-from-top-1">
                                  <input
                                    type="color"
                                    value={options.uniformTieColor}
                                    onChange={(e) =>
                                      handleOptionChange(
                                        "uniformTieColor",
                                        e.target.value
                                      )
                                    }
                                    // className="w-8 h-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                                    className="rounded-lg cursor-pointer bg-transparent border-none p-0"
                                    style={{ width: "60%", height: "30px" }}
                                  />
                                  <div>
                                    <span
                                      className="font-mono text-indigo-400 font-bold uppercase"
                                      style={{
                                        height: "30px",
                                        fontSize: "15px"
                                      }}
                                    >
                                      {options.uniformTieColor}
                                    </span>
                                  </div>
                                  {/* <span
                                    className="text-[10px] font-mono text-slate-500 uppercase"
                                    style={{ height: "30px", fontSize: "12px" }}
                                  >
                                    {options.uniformTieColor}
                                  </span> */}
                                </div>
                              )}
                            </div>
                          )}
                        </div>

                        {/* PINAFORE SPECIFIC SHIRT SETTINGS */}
                        {options.uniformType === "pinafore" && (
                          <div className="space-y-6 bg-slate-900/40 p-6 rounded-3xl border border-indigo-500/30 animate-in fade-in slide-in-from-right-2">
                            <h4 className="text-[10px] font-bold text-indigo-400 uppercase tracking-widest border-b border-indigo-500/20 pb-2 mb-4">
                              Matching Blouse Settings
                            </h4>
                            <div className="space-y-6">
                              <div className="space-y-3">
                                <label className="text-[10px] font-bold text-slate-500 uppercase block">
                                  Blouse Color
                                </label>
                                <div className="flex items-center space-x-4 bg-slate-950/50 p-2 rounded-xl border border-slate-800">
                                  <input
                                    type="color"
                                    value={options.pinaforeShirtColor}
                                    onChange={(e) =>
                                      handleOptionChange(
                                        "pinaforeShirtColor",
                                        e.target.value
                                      )
                                    }
                                    // className="w-8 h-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                                    className="rounded-lg cursor-pointer bg-transparent border-none p-0"
                                    style={{ width: "60%", height: "30px" }}
                                  />
                                  <span className="text-[15px] font-mono text-slate-400 font-bold uppercase">
                                    {options.pinaforeShirtColor}
                                  </span>
                                </div>
                              </div>

                              <div className="space-y-3">
                                <label className="text-[10px] font-bold text-slate-500 uppercase block">
                                  Blouse Pattern
                                </label>
                                <div className="flex bg-slate-950 rounded-xl p-1 border border-slate-800">
                                  <button
                                    onClick={() =>
                                      handleOptionChange(
                                        "pinaforeShirtPattern",
                                        "plain"
                                      )
                                    }
                                    className={`flex-1 py-1.5 rounded-lg text-[9px] font-bold transition-all ${
                                      options.pinaforeShirtPattern === "plain"
                                        ? "bg-indigo-600 text-white shadow-md"
                                        : "text-slate-500 hover:text-slate-300"
                                    }`}
                                  >
                                    PLAIN
                                  </button>
                                  <button
                                    onClick={() =>
                                      handleOptionChange(
                                        "pinaforeShirtPattern",
                                        "striped"
                                      )
                                    }
                                    className={`flex-1 py-1.5 rounded-lg text-[9px] font-bold transition-all ${
                                      options.pinaforeShirtPattern === "striped"
                                        ? "bg-indigo-600 text-white shadow-md"
                                        : "text-slate-500 hover:text-slate-300"
                                    }`}
                                  >
                                    STRIPED
                                  </button>
                                </div>
                              </div>

                              {options.pinaforeShirtPattern === "striped" && (
                                <div className="space-y-4 animate-in slide-in-from-top-1 bg-slate-950/50 p-3 rounded-xl border border-slate-800">
                                  <div className="space-y-2">
                                    <label className="text-[10px] font-bold text-slate-500 uppercase block">
                                      Stripe Color
                                    </label>
                                    <div className="flex items-center space-x-3">
                                      <input
                                        type="color"
                                        value={options.pinaforeShirtStripeColor}
                                        onChange={(e) =>
                                          handleOptionChange(
                                            "pinaforeShirtStripeColor",
                                            e.target.value
                                          )
                                        }
                                        // className="w-8 h-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                                        className="rounded-lg cursor-pointer bg-transparent border-none p-0"
                                        style={{ width: "60%", height: "30px" }}
                                      />
                                      <span className="text-[15px] font-mono text-slate-400 font-bold uppercase">
                                        {options.pinaforeShirtStripeColor}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="space-y-2">
                                    <label className="text-[10px] font-bold text-slate-500 uppercase block">
                                      Stripe Width
                                    </label>
                                    <div className="flex bg-slate-900 rounded-lg p-1 space-x-1">
                                      {["thin", "medium", "thick"].map((w) => (
                                        <button
                                          key={w}
                                          onClick={() =>
                                            handleOptionChange(
                                              "pinaforeShirtStripeWidth",
                                              w
                                            )
                                          }
                                          className={`flex-1 py-1 rounded text-[9px] font-bold transition-all ${
                                            options.pinaforeShirtStripeWidth ===
                                            w
                                              ? "bg-indigo-600 text-white"
                                              : "text-slate-600 hover:text-slate-400"
                                          }`}
                                        >
                                          {w.toUpperCase()}
                                        </button>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              )}

                              <div className="space-y-3">
                                <label className="text-[10px] font-bold text-slate-500 uppercase block">
                                  Sleeve Length
                                </label>
                                <div className="flex bg-slate-950 rounded-xl p-1 border border-slate-800">
                                  <button
                                    onClick={() =>
                                      handleOptionChange(
                                        "pinaforeShirtSleeves",
                                        "short"
                                      )
                                    }
                                    className={`flex-1 py-1.5 rounded-lg text-[9px] font-bold transition-all ${
                                      options.pinaforeShirtSleeves === "short"
                                        ? "bg-indigo-600 text-white shadow-md"
                                        : "text-slate-500 hover:text-slate-300"
                                    }`}
                                  >
                                    SHORT
                                  </button>
                                  <button
                                    onClick={() =>
                                      handleOptionChange(
                                        "pinaforeShirtSleeves",
                                        "long"
                                      )
                                    }
                                    className={`flex-1 py-1.5 rounded-lg text-[9px] font-bold transition-all ${
                                      options.pinaforeShirtSleeves === "long"
                                        ? "bg-indigo-600 text-white shadow-md"
                                        : "text-slate-500 hover:text-slate-300"
                                    }`}
                                  >
                                    LONG
                                  </button>
                                </div>
                              </div>

                              {options.pinaforeShirtSleeves === "short" && (
                                <div className="space-y-3 animate-in fade-in slide-in-from-top-1">
                                  <label className="text-[10px] font-bold text-slate-500 uppercase block">
                                    Short Sleeve Style
                                  </label>
                                  <div className="flex bg-slate-950 rounded-xl p-1 border border-slate-800">
                                    <button
                                      onClick={() =>
                                        handleOptionChange(
                                          "pinaforeSleeveCuff",
                                          "plain"
                                        )
                                      }
                                      className={`flex-1 py-1.5 rounded-lg text-[9px] font-bold transition-all ${
                                        options.pinaforeSleeveCuff === "plain"
                                          ? "bg-indigo-600 text-white shadow-md"
                                          : "text-slate-500 hover:text-slate-300"
                                      }`}
                                    >
                                      PLAIN CUFF
                                    </button>
                                    <button
                                      onClick={() =>
                                        handleOptionChange(
                                          "pinaforeSleeveCuff",
                                          "elasticated"
                                        )
                                      }
                                      className={`flex-1 py-1.5 rounded-lg text-[9px] font-bold transition-all ${
                                        options.pinaforeSleeveCuff ===
                                        "elasticated"
                                          ? "bg-indigo-600 text-white shadow-md"
                                          : "text-slate-500 hover:text-slate-300"
                                      }`}
                                    >
                                      ELASTICATED
                                    </button>
                                  </div>
                                  <p
                                    className="text-slate-600 uppercase font-bold text-center"
                                    style={{
                                      color: "#f59e0b",
                                      fontSize: "x-small"
                                    }}
                                  >
                                    Elasticated creates a gentle puff sleeve
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* CASUAL MODE */}
                  {options.attireMode === "casual" && (
                    <div className="space-y-8 animate-in fade-in slide-in-from-top-2 border-t border-slate-800/50 pt-8">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                        {/* TOPS SECTION */}
                        <div className="space-y-6 bg-slate-900/40 p-6 rounded-3xl border border-slate-800">
                          <h4 className="text-xs font-bold text-slate-400 uppercase tracking-widest border-b border-slate-800 pb-3">
                            Tops
                          </h4>
                          <div className="grid grid-cols-2 gap-2">
                            {[
                              { type: "shirt-plain", label: "Plain Shirt" },
                              { type: "shirt-checked", label: "Checked Shirt" },
                              { type: "shirt-striped", label: "Striped Shirt" },
                              { type: "tshirt", label: "Polo T-Shirt" },
                              { type: "sweatshirt", label: "Sweatshirt" },
                              { type: "croptop", label: "Crop Top (Girls)" },
                              { type: "short-top", label: "Short Top" },
                              { type: "long-top", label: "Long Top" },
                              { type: "turtle-neck", label: "Turtle Neck" },
                              {
                                type: "oversized-tshirt",
                                label: "Oversized T-Shirt"
                              }
                            ].map(({ type, label }) => (
                              <button
                                key={type}
                                onClick={() =>
                                  handleOptionChange("casualTopType", type)
                                }
                                className={`py-2 px-1 rounded-lg text-[9px] font-bold border transition-all ${
                                  options.casualTopType === type
                                    ? "bg-indigo-600 text-white"
                                    : "bg-slate-950 border-slate-800 text-slate-600"
                                }`}
                              >
                                {label.toUpperCase()}
                              </button>
                            ))}
                          </div>
                          <div className="flex items-center space-x-4 bg-slate-950/50 p-3 rounded-xl border border-slate-800">
                            <input
                              type="color"
                              value={options.casualTopColor}
                              onChange={(e) =>
                                handleOptionChange(
                                  "casualTopColor",
                                  e.target.value
                                )
                              }
                              // className="w-8 h-8 rounded-lg cursor-pointer"
                              className="rounded-lg cursor-pointer"
                              style={{ width: "40%", height: "30px" }}
                            />
                            <span className="text-[12px] font-mono text-slate-500 uppercase font-bold">
                              Top Color: {options.casualTopColor}
                            </span>
                          </div>
                        </div>

                        {/* OUTERWEAR SECTION */}
                        <div className="space-y-6 bg-slate-900/40 p-6 rounded-3xl border border-slate-800">
                          <h4 className="text-xs font-bold text-slate-400 uppercase tracking-widest border-b border-slate-800 pb-3">
                            Outerwear
                          </h4>
                          <div className="grid grid-cols-2 gap-2">
                            {[
                              { type: "hoodie", label: "Hoodie" },
                              {
                                type: "oversized-hoodie",
                                label: "Oversized Hoodie"
                              },
                              { type: "zip-jacket", label: "Zip Jacket" },
                              { type: "denim-jacket", label: "Denim Jacket" },
                              { type: "sweater", label: "Sweater" },
                              { type: "none", label: "None" }
                            ].map(({ type, label }) => (
                              <button
                                key={type}
                                onClick={() =>
                                  handleOptionChange("casualOuterType", type)
                                }
                                className={`py-2 px-1 rounded-lg text-[9px] font-bold border transition-all ${
                                  options.casualOuterType === type
                                    ? "bg-indigo-600 text-white"
                                    : "bg-slate-950 border-slate-800 text-slate-600"
                                }`}
                              >
                                {label.toUpperCase()}
                              </button>
                            ))}
                          </div>

                          {/* SWEATER STYLE SELECTION */}
                          {options.casualOuterType === "sweater" && (
                            <div className="space-y-4 pt-2 border-t border-slate-800 animate-in fade-in slide-in-from-top-2 duration-300">
                              <label className="text-[10px] font-bold text-slate-500 uppercase tracking-widest block">
                                Sweater Knit Style
                              </label>
                              <div className="grid grid-cols-2 gap-2">
                                {[
                                  { type: "crew-neck", label: "Crew Neck" },
                                  { type: "v-neck", label: "V-Neck" },
                                  {
                                    type: "cable-knit",
                                    label: "Chunk/Cable Knit"
                                  },
                                  { type: "vest", label: "Vest" },
                                  { type: "fair-isle", label: "Fair Isle" }
                                ].map(({ type, label }) => (
                                  <button
                                    key={type}
                                    onClick={() =>
                                      handleOptionChange(
                                        "casualSweaterStyle",
                                        type
                                      )
                                    }
                                    className={`py-2 px-1 rounded-lg text-[9px] font-bold border transition-all ${
                                      options.casualSweaterStyle === type
                                        ? "bg-indigo-500 border-400 text-white"
                                        : "bg-slate-950 border-slate-800 text-slate-600"
                                    }`}
                                  >
                                    {label.toUpperCase()}
                                  </button>
                                ))}
                              </div>
                            </div>
                          )}

                          {options.casualOuterType !== "none" && (
                            <div className="flex items-center space-x-4 bg-slate-950/50 p-3 rounded-xl border border-slate-800">
                              <input
                                type="color"
                                value={options.casualOuterColor}
                                onChange={(e) =>
                                  handleOptionChange(
                                    "casualOuterColor",
                                    e.target.value
                                  )
                                }
                                // className="w-8 h-8 rounded-lg cursor-pointer"
                                className="cursor-pointer"
                                style={{ width: "40%", height: "30px" }}
                              />
                              <span className="text-[12px] font-mono text-slate-500 uppercase font-bold">
                                Outer Color: {options.casualOuterColor}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* KEEP ORIGINAL MODE */}
                  {options.attireMode === "keepOriginal" && (
                    <div className="flex flex-col items-center justify-center p-12 text-slate-600 border-2 border-dashed border-slate-800 rounded-[2rem] animate-in fade-in border-t border-slate-800/50 pt-8">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-10 w-10 mb-4 opacity-20"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        />
                      </svg>
                      <p className="text-sm font-bold uppercase tracking-widest">
                        No Dress Changes
                      </p>
                      <p className="text-[10px] max-w-[200px] text-center mt-2 opacity-60 italic">
                        We will strictly maintain the clothing from your source
                        image.
                      </p>
                    </div>
                  )}
                </div>
              </div>

              {/* FACE & GROOMING SECTION */}
              <div className="pt-8 border-t border-slate-800 space-y-6">
                <h3 className="text-sm font-bold text-slate-400 uppercase tracking-wider">
                  Face & Grooming
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div className="space-y-4">
                    <label className="text-xs font-bold text-slate-500 block">
                      Facial Hair (Exclusive)
                    </label>
                    <div className="flex flex-col space-y-2">
                      {[
                        {
                          val: "default",
                          label: "No Change / Default Grooming"
                        },
                        { val: "keep", label: "Keep Original Beard/Mustache" },
                        { val: "shaven", label: "Clean Shaven" }
                      ].map((item) => (
                        <React.Fragment key={item.val}>
                          <label className="flex items-center space-x-3 cursor-pointer group">
                            <input
                              type="radio"
                              name="facialHair"
                              checked={options.facialHair === item.val}
                              onChange={() =>
                                handleOptionChange("facialHair", item.val)
                              }
                              // className="w-4 h-4 text-indigo-600 bg-slate-800 border-slate-700"
                              className="w-4 text-indigo-600 bg-slate-800 border-slate-700"
                              style={{ height: "15px", marginBottom: "4px" }}
                            />
                            <span className="text-sm text-slate-400 group-hover:text-slate-200">
                              {item.label}
                            </span>
                          </label>
                          {item.val === "shaven" &&
                            options.facialHair === "shaven" && (
                              <div className="pl-7 animate-in slide-in-from-top-1">
                                <label className="flex items-center space-x-2 cursor-pointer group">
                                  <input
                                    type="checkbox"
                                    checked={options.keepMustache}
                                    onChange={(e) =>
                                      handleOptionChange(
                                        "keepMustache",
                                        e.target.checked
                                      )
                                    }
                                    // className="w-3.5 h-3.5 rounded text-indigo-500 bg-slate-800 border-slate-700"
                                    className="w-4 rounded text-indigo-500 bg-slate-800 border-slate-700"
                                    style={{
                                      height: "15px",
                                      marginBottom: "4px"
                                    }}
                                  />
                                  <span className="text-[10px] font-bold text-slate-500 group-hover:text-slate-400 uppercase">
                                    Keep Original Mustache
                                  </span>
                                </label>
                              </div>
                            )}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                  <div className="grid grid-cols-1 gap-3">
                    {[
                      { k: "keepEyewear", l: "Keep Original Eyewear" },
                      { k: "keepHair", l: "Keep Original Hair Style" },
                      {
                        k: "keepFacialChars",
                        l: "Keep Facial Characteristics"
                      },
                      { k: "evenLighting", l: "Even Lighting" },
                      { k: "facingCamera", l: "Facing Camera" },
                      { k: "isProfileView", l: "Profile View (Strict)" },
                      { k: "isCloseup", l: "Closeup Shot" },
                      {
                        k: "hasHeadroomAdjust",
                        l: "Adjust Headroom (Space Above Head)"
                      },
                      {
                        k: "noBlemishes",
                        l: "No Blemishes (Remove Spots/Acne)"
                      },
                      {
                        k: "removeHandProps",
                        l: "Remove Hand Props (Cups/Phones)"
                      },
                      {
                        k: "removeHandGestures",
                        l: "Remove Hand Gestures (Peace/Waving)"
                      }
                    ].map((item) => (
                      <div key={item.k} className="space-y-2">
                        <label className="flex items-center space-x-3 cursor-pointer group">
                          <input
                            type="checkbox"
                            checked={options[item.k]}
                            onChange={(e) =>
                              handleOptionChange(item.k, e.target.checked)
                            }
                            // className="w-4 h-4 rounded text-indigo-500 border-slate-700 bg-slate-800"
                            className="w-4 rounded text-indigo-500 border-slate-700 bg-slate-800"
                            style={{ height: "15px", marginBottom: "4px" }}
                          />
                          <span className="text-sm text-slate-400 group-hover:text-slate-200">
                            {item.l}
                          </span>
                        </label>
                        {item.k === "isProfileView" &&
                          options.isProfileView && (
                            <div className="pl-7 pr-2 space-y-4 animate-in slide-in-from-top-1">
                              <div className="space-y-2">
                                <span className="text-[10px] font-bold text-slate-500 uppercase">
                                  View Direction
                                </span>
                                <div className="flex items-center bg-slate-900 rounded-lg p-1 space-x-1">
                                  <button
                                    onClick={() =>
                                      handleOptionChange(
                                        "profileDirection",
                                        "left"
                                      )
                                    }
                                    className={`flex-1 px-3 py-1.5 rounded-md text-[10px] font-bold transition-all ${
                                      options.profileDirection === "left"
                                        ? "bg-indigo-600 text-white shadow-md"
                                        : "text-slate-500 hover:text-slate-300"
                                    }`}
                                  >
                                    LEFT
                                  </button>
                                  <button
                                    onClick={() =>
                                      handleOptionChange(
                                        "profileDirection",
                                        "right"
                                      )
                                    }
                                    className={`flex-1 px-3 py-1.5 rounded-md text-[10px] font-bold transition-all ${
                                      options.profileDirection === "right"
                                        ? "bg-indigo-600 text-white shadow-md"
                                        : "text-slate-500 hover:text-slate-300"
                                    }`}
                                  >
                                    RIGHT
                                  </button>
                                </div>
                              </div>
                              <div className="space-y-2">
                                <div className="flex justify-between items-center text-[10px] font-bold text-slate-500 uppercase">
                                  <span>Profile Angle (0-90°)</span>
                                  <span className="text-indigo-400">
                                    {options.profileAngle}°
                                  </span>
                                </div>
                                <input
                                  type="range"
                                  min="0"
                                  max="90"
                                  value={options.profileAngle}
                                  onChange={(e) =>
                                    handleOptionChange(
                                      "profileAngle",
                                      parseInt(e.target.value)
                                    )
                                  }
                                  className="w-full h-1 bg-slate-800 rounded-lg appearance-none cursor-pointer accent-indigo-500"
                                />
                              </div>
                            </div>
                          )}
                        {item.k === "isCloseup" && options.isCloseup && (
                          <div className="pl-7 pr-2 space-y-1 animate-in slide-in-from-top-1">
                            <div className="flex justify-between items-center text-[10px] font-bold text-slate-500 uppercase">
                              <span>Intensity (Tighter Crop)</span>
                              <span className="text-indigo-400">
                                {options.closeupIntensity}%
                              </span>
                            </div>
                            <input
                              type="range"
                              min="0"
                              max="100"
                              value={options.closeupIntensity}
                              onChange={(e) =>
                                handleOptionChange(
                                  "closeupIntensity",
                                  parseInt(e.target.value)
                                )
                              }
                              className="w-full h-1 bg-slate-800 rounded-lg appearance-none cursor-pointer accent-indigo-500"
                            />
                          </div>
                        )}
                        {item.k === "hasHeadroomAdjust" &&
                          options.hasHeadroomAdjust && (
                            <div className="pl-7 pr-2 space-y-1 animate-in slide-in-from-top-1">
                              <div className="flex justify-between items-center text-[10px] font-bold text-slate-500 uppercase">
                                <span>
                                  {options.headroomLevel > 50
                                    ? "More Headroom"
                                    : options.headroomLevel < 50
                                    ? "Less Headroom"
                                    : "Standard"}
                                </span>
                                <span className="text-indigo-400">
                                  {options.headroomLevel}%
                                </span>
                              </div>
                              <input
                                type="range"
                                min="0"
                                max="100"
                                value={options.headroomLevel}
                                onChange={(e) =>
                                  handleOptionChange(
                                    "headroomLevel",
                                    parseInt(e.target.value)
                                  )
                                }
                                className="w-full h-1 bg-slate-800 rounded-lg appearance-none cursor-pointer accent-indigo-500"
                              />
                            </div>
                          )}
                      </div>
                    ))}

                    <div className="space-y-2 pt-2">
                      <label className="flex items-center space-x-3 cursor-pointer group">
                        <input
                          type="checkbox"
                          checked={options.subjectBokeh}
                          onChange={(e) =>
                            handleOptionChange("subjectBokeh", e.target.checked)
                          }
                          // className="w-4 h-4 rounded text-indigo-500 border-slate-700 bg-slate-800"
                          className="w-4 rounded text-indigo-500 border-slate-700 bg-slate-800"
                          style={{ height: "15px", marginBottom: "4px" }}
                        />
                        <span className="text-sm text-slate-400 group-hover:text-slate-200">
                          Subject Bokeh (Cinematic Depth)
                        </span>
                      </label>
                      {options.subjectBokeh && (
                        <div className="pl-7 pr-2 space-y-1 animate-in slide-in-from-top-1">
                          <div className="flex justify-between items-center text-[10px] font-bold text-slate-500 uppercase">
                            <span>Depth Intensity</span>
                            <span className="text-indigo-400">
                              {options.subjectBokehDepth}%
                            </span>
                          </div>
                          <input
                            type="range"
                            min="0"
                            max="100"
                            value={options.subjectBokehDepth}
                            onChange={(e) =>
                              handleOptionChange(
                                "subjectBokehDepth",
                                parseInt(e.target.value)
                              )
                            }
                            className="w-full h-1 bg-slate-800 rounded-lg appearance-none cursor-pointer accent-indigo-500"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* ENVIRONMENT & SIZE SECTION */}
              <div className="pt-8 border-t border-slate-800 space-y-6">
                <h3 className="text-sm font-bold text-slate-400 uppercase tracking-wider">
                  Environment & Framing
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="space-y-3">
                    <label className="text-xs font-bold text-slate-500">
                      Expression Selection
                    </label>
                    <select
                      value={options.expression}
                      onChange={(e) =>
                        handleOptionChange("expression", e.target.value)
                      }
                      // className="w-full h-10 bg-slate-900 border border-slate-700 rounded-lg px-3 text-xs outline-none font-bold"
                      className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 text-xs outline-none font-bold"
                    >
                      <option value="original">
                        Strictly Keep Original Expression (1:1)
                      </option>
                      <option value="smile">Professional Studio Smile</option>
                      <option value="confident">
                        Professional & Confident (Neutral)
                      </option>
                    </select>
                    {/* <p className="text-[9px] text-indigo-400 font-bold uppercase tracking-tight mt-1" */}
                    <p
                      className="space-y-2 py-2 text-[9px] font-bold uppercase tracking-tight mt-1"
                      style={{ color: "#f59e0b" }}
                    >
                      {options.expression === "original"
                        ? "Identity Locked: Mouth and gaze will not be altered."
                        : "Note: AI may subtly shift facial features for the chosen expression."}
                    </p>
                  </div>
                  <div className="space-y-3">
                    <label className="text-xs font-bold text-slate-500">
                      Output Size
                    </label>
                    <select
                      value={options.aspectRatio}
                      onChange={(e) =>
                        handleOptionChange("aspectRatio", e.target.value)
                      }
                      // className="w-full h-10 bg-slate-900 border border-slate-700 rounded-lg px-3 text-xs outline-none"
                      className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 text-xs outline-none"
                    >
                      <option value="7 inch by 8.05 inch">
                        7" x 8.05" (Default Pro)
                      </option>
                      <option value="3:4">3:4 Portrait</option>
                      <option value="3:2">3:2 Classic 35mm</option>
                      <option value="2:3">2:3 Portrait Orientation</option>
                      <option value="1:1">1:1 Square</option>
                      <option value="4:3">4:3 Landscape</option>
                      <option value="16:9">16:9 Cinematic</option>
                      <option value="9:16">9:16 Full Portrait</option>
                    </select>
                  </div>
                </div>

                <div className="space-y-6">
                  <div className="flex items-center justify-between">
                    <label className="text-xs font-bold text-slate-500">
                      Background Reference Image (Optional)
                    </label>
                    {hasBgRef && (
                      <button
                        onClick={() => setBgRef(null)}
                        className="text-[10px] text-red-400 hover:underline"
                      >
                        Remove Reference
                      </button>
                    )}
                  </div>

                  <ImageUploader
                    label="Custom Background Reference"
                    description="Upload an image to use as background"
                    image={bgRef}
                    onUpload={(img) =>
                      validateAndSetImage(
                        apikey,
                        img,
                        setBgRef,
                        "Background Reference"
                      )
                    }
                    onClear={() => {
                      if (
                        document
                          .getElementById("loading-overlay")
                          .classList.contains("hidden")
                      )
                        setBgRef(null);
                    }}
                  />
                  <p className="flex flex-col items-center space-y-2 py-2 text-[10px] text-amber-500 font-semibold mt-1 uppercase tracking-tight">
                    Images will be rejected if decent images wearing decent
                    attires are not provided.
                  </p>

                  {hasBgRef && (
                    <div className="bg-indigo-600/10 border border-indigo-500/20 p-3 rounded-xl flex flex-col space-y-2 animate-in slide-in-from-top-1">
                      <div className="flex items-center space-x-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4 text-indigo-400"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                            clipRule="evenodd"
                          />
                        </svg>
                        <span className="text-[10px] text-indigo-200 font-bold uppercase tracking-tight">
                          Using reference image background. Preset styles
                          disabled.
                        </span>
                      </div>
                      <div className="space-y-2">
                        <label className="flex items-center space-x-2 cursor-pointer">
                          <input
                            type="checkbox"
                            checked={options.blurBgRef}
                            onChange={(e) =>
                              handleOptionChange("blurBgRef", e.target.checked)
                            }
                            // className="w-3.5 h-3.5 rounded text-indigo-500"
                            className="w-4 rounded text-indigo-500"
                            style={{ height: "15px", marginBottom: "4px" }}
                          />
                          <span className="text-xs text-slate-400">
                            Apply Blur to Reference Background
                          </span>
                        </label>
                        {(options.blurBgRef || bgBlur) && (
                          <div className="pl-6 space-y-1 animate-in slide-in-from-top-1">
                            <div className="flex justify-between items-center text-[10px] font-bold text-slate-500 uppercase">
                              <span>Blur Depth</span>
                              <span className="text-indigo-400">
                                {bgBlurDepth}%
                              </span>
                            </div>
                            <input
                              type="range"
                              min="0"
                              max="100"
                              value={bgBlurDepth}
                              onChange={(e) =>
                                setBgBlurDepth(parseInt(e.target.value))
                              }
                              className="w-full h-1 bg-slate-800 rounded-lg appearance-none cursor-pointer accent-indigo-500"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  <div
                    className={`space-y-4 transition-all duration-300 ${
                      isBgSettingsDisabled
                        ? "opacity-30 grayscale pointer-events-none"
                        : "opacity-100"
                    }`}
                  >
                    <div className="flex justify-between items-center px-1">
                      <label className="text-xs font-bold text-slate-500">
                        Preset Background Types
                      </label>
                      {bgType !== "none" && !isBgSettingsDisabled && (
                        <button
                          onClick={() => setBgType("none")}
                          className="text-[10px] text-red-400 hover:underline"
                        >
                          Clear Preset
                        </button>
                      )}
                    </div>

                    <div className="grid grid-cols-2 md:grid-cols-5 gap-2 mb-4">
                      {["none", "gradient", "retro", "office", "clean"].map(
                        (t) => (
                          <button
                            key={t}
                            disabled={isBgSettingsDisabled}
                            onClick={() => setBgType(t)}
                            className={`py-2 px-1 rounded-lg text-[10px] font-bold border transition-all ${
                              bgType === t
                                ? "bg-indigo-600 border-indigo-500 text-white shadow-lg"
                                : "bg-slate-900 border-slate-800 text-slate-500 hover:bg-slate-800"
                            }`}
                          >
                            {t.toUpperCase()}
                          </button>
                        )
                      )}
                    </div>

                    {!isBgSettingsDisabled && bgType !== "none" && (
                      <div className="bg-slate-900/40 p-4 rounded-2xl border border-slate-800 space-y-4 mb-4">
                        <div className="flex flex-wrap items-center gap-6">
                          <div className="flex items-center space-x-2">
                            <input
                              type="checkbox"
                              id="bgNoise"
                              checked={bgNoise}
                              onChange={(e) => setBgNoise(e.target.checked)}
                              // className="w-4 h-4 rounded text-indigo-500 bg-slate-800 border-slate-700"
                              className="w-4 rounded text-indigo-500 bg-slate-800 border-slate-700"
                              style={{ height: "15px", marginBottom: "4px" }}
                            />
                            <label
                              htmlFor="bgNoise"
                              className="text-[10px] font-bold text-slate-400 uppercase tracking-widest cursor-pointer"
                            >
                              Backdrop Noise (Grain)
                            </label>
                          </div>
                          <div className="flex items-center space-x-2">
                            <input
                              type="checkbox"
                              id="bgBlur"
                              checked={bgBlur}
                              onChange={(e) => setBgBlur(e.target.checked)}
                              // className="w-4 h-4 rounded text-indigo-500 bg-slate-800 border-slate-700"
                              className="w-4 rounded text-indigo-500 bg-slate-800 border-slate-700"
                              style={{ height: "15px", marginBottom: "4px" }}
                            />
                            <label
                              htmlFor="bgBlur"
                              className="text-[10px] font-bold text-slate-400 uppercase tracking-widest cursor-pointer"
                            >
                              Backdrop Blur
                            </label>
                          </div>
                        </div>

                        {(bgNoise || bgBlur) && (
                          <div className="space-y-4 pt-2 border-t border-slate-800 animate-in slide-in-from-top-1">
                            {bgNoise && (
                              <div className="space-y-3">
                                <div className="flex justify-between items-center">
                                  <div className="flex justify-between items-center text-[10px] font-bold text-slate-500 uppercase flex-1 mr-4">
                                    <span>Noise Intensity</span>
                                    <span className="text-indigo-400">
                                      {noiseLevel}%
                                    </span>
                                  </div>
                                  <label className="flex items-center space-x-2 cursor-pointer">
                                    <input
                                      type="checkbox"
                                      checked={bgNoiseMonochromatic}
                                      onChange={(e) =>
                                        setBgNoiseMonochromatic(
                                          e.target.checked
                                        )
                                      }
                                      // className="w-3 h-3 rounded text-indigo-500 bg-slate-800 border-slate-700"
                                      className="w-3 rounded text-indigo-500 bg-slate-800 border-slate-700"
                                      style={{
                                        height: "15px",
                                        marginBottom: "4px"
                                      }}
                                    />
                                    <span className="text-[9px] font-bold text-slate-500 uppercase">
                                      Monochromatic
                                    </span>
                                  </label>
                                </div>
                                <input
                                  type="range"
                                  min="0"
                                  max="100"
                                  value={noiseLevel}
                                  onChange={(e) =>
                                    setNoiseLevel(parseInt(e.target.value))
                                  }
                                  className="w-full h-1 bg-slate-800 rounded-lg appearance-none cursor-pointer accent-indigo-500"
                                />
                              </div>
                            )}
                            {bgBlur && (
                              <div className="space-y-3">
                                <div className="flex justify-between items-center text-[10px] font-bold text-slate-500 uppercase">
                                  <span>Blur Intensity</span>
                                  <span className="text-indigo-400">
                                    {bgBlurDepth}%
                                  </span>
                                </div>
                                <input
                                  type="range"
                                  min="0"
                                  max="100"
                                  value={bgBlurDepth}
                                  onChange={(e) =>
                                    setBgBlurDepth(parseInt(e.target.value))
                                  }
                                  className="w-full h-1 bg-slate-800 rounded-lg appearance-none cursor-pointer accent-indigo-500"
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}

                    {!isBgSettingsDisabled && renderBackgroundPreview()}

                    {bgType === "gradient" && !isBgSettingsDisabled && (
                      <div className="space-y-6 pt-4 animate-in slide-in-from-top-2">
                        <div className="flex items-center justify-between border-b border-slate-800 pb-4">
                          <div className="space-y-1">
                            <span className="text-[10px] font-bold text-slate-500 uppercase">
                              Gradient Type
                            </span>
                            {/* <div className="flex items-center bg-slate-900 rounded-lg p-1 space-x-1"> */}
                            <div className="flex items-center bg-slate-900  p-5 space-x-4">
                              <button
                                onClick={() => setGradientStyle("linear")}
                                className={`px-4 py-1.5 rounded-md text-[10px] font-bold transition-all ${
                                  gradientStyle === "linear"
                                    ? "bg-indigo-600 text-white shadow-md"
                                    : "text-slate-500 hover:text-slate-300"
                                }`}
                              >
                                LINEAR
                              </button>
                              <button
                                onClick={() => setGradientStyle("radial")}
                                className={`px-4 py-1.5 rounded-md text-[10px] font-bold transition-all ${
                                  gradientStyle === "radial"
                                    ? "bg-indigo-600 text-white shadow-md"
                                    : "text-slate-500 hover:text-slate-300"
                                }`}
                              >
                                RADIAL
                              </button>
                            </div>
                          </div>

                          <div className="flex items-center space-x-2">
                            {gradientStyle === "linear" && (
                              <div className="space-y-1 mr-4">
                                <span className="text-[10px] font-bold text-slate-500 uppercase block text-right">
                                  Angle: {gradientAngle}°
                                </span>
                                <input
                                  type="range"
                                  min="0"
                                  max="360"
                                  value={gradientAngle}
                                  onChange={(e) =>
                                    setGradientAngle(parseInt(e.target.value))
                                  }
                                  className="w-24 accent-indigo-500"
                                />
                              </div>
                            )}
                            <button
                              onClick={handleReverseGradient}
                              className="bg-slate-800 hover:bg-slate-700 p-2 rounded-lg text-indigo-400 transition-colors"
                              title="Reverse Gradient"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                // className="h-5 w-5"
                                className="w-5"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                style={{ height: "20px" }}
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                                />
                              </svg>
                            </button>
                            <button
                              onClick={handleRandomizeGradient}
                              className="bg-slate-800 hover:bg-slate-700 p-2 rounded-lg text-indigo-400 transition-colors"
                              title="Randomize Colors"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                // className="h-5 w-5"
                                className="w-5"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                style={{ height: "20px" }}
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357-2H15"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>

                        <div className="space-y-4">
                          <div className="flex justify-between items-center">
                            <span className="text-[10px] font-bold text-slate-500 uppercase tracking-widest">
                              Color Stops (Max 5)
                            </span>
                            <button
                              onClick={addGradientStop}
                              disabled={gradientStops.length >= 5}
                              className="text-[10px] font-bold text-indigo-400 hover:text-indigo-300 disabled:opacity-30 flex items-center space-x-1"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                // className="h-3 w-3"
                                className="w-3"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={3}
                                  d="M12 4v16m8-8H4"
                                />
                              </svg>
                              <span>ADD STOP</span>
                            </button>
                          </div>

                          <div className="space-y-2">
                            {gradientStops.map((stop, index) => (
                              <div
                                key={stop.id}
                                className="flex items-center space-x-4 bg-slate-900/50 p-2 rounded-xl border border-slate-800 animate-in slide-in-from-left-1 duration-200"
                              >
                                <div className="flex items-center space-x-2 flex-1">
                                  <input
                                    type="color"
                                    value={stop.color}
                                    onChange={(e) =>
                                      updateGradientStop(stop.id, {
                                        color: e.target.value
                                      })
                                    }
                                    // className="w-8 h-8 rounded-full cursor-pointer bg-transparent border-none p-0"
                                    className="w-8 rounded-full cursor-pointer bg-transparent border-none p-0"
                                    style={{ height: "30px" }}
                                  />
                                  <span className="text-[10px] font-mono text-slate-400 uppercase w-16">
                                    {stop.color}
                                  </span>
                                  <input
                                    type="range"
                                    min="0"
                                    max="100"
                                    value={stop.offset}
                                    onChange={(e) =>
                                      updateGradientStop(stop.id, {
                                        offset: parseInt(e.target.value)
                                      })
                                    }
                                    className="flex-1 h-1 bg-slate-800 rounded-lg appearance-none cursor-pointer accent-indigo-500"
                                  />
                                  <span className="text-[10px] font-bold text-slate-500 w-8 text-right">
                                    {stop.offset}%
                                  </span>
                                </div>
                                <button
                                  onClick={() => removeGradientStop(stop.id)}
                                  disabled={gradientStops.length <= 2}
                                  className="text-slate-600 hover:text-red-400 disabled:opacity-0 transition-colors"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    // className="h-4 w-4"
                                    className="w-4"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M6 18L18 6M6 6l12 12"
                                    />
                                  </svg>
                                </button>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}

                    {(bgType === "retro" || bgType === "clean") &&
                      !isBgSettingsDisabled && (
                        <div className="flex flex-col space-y-4 pt-2 animate-in slide-in-from-left-2">
                          <label className="text-[10px] font-bold text-slate-600 uppercase tracking-widest block">
                            {bgType === "retro"
                              ? "Select Retro Canvas Base Color"
                              : "Select Background Color"}
                          </label>
                          <div className="flex items-center space-x-4 bg-slate-900/50 p-4 rounded-2xl border border-slate-800">
                            <input
                              type="color"
                              value={bgColor}
                              disabled={isBgSettingsDisabled}
                              onChange={(e) => setBgColor(e.target.value)}
                              // className="w-12 h-12 cursor-pointer bg-slate-800 border-2 border-slate-700 p-1 rounded-xl hover:border-indigo-500 transition-all duration-300"
                              className="cursor-pointer bg-slate-800 border-2 border-slate-700 p-1 rounded-xl hover:border-indigo-500 transition-all duration-300"
                              style={{ width: "80%", height: "50 px" }}
                            />
                            <div className="flex-col">
                              <span className="text-sm font-mono text-indigo-600 uppercase font-bold">
                                {bgColor}
                              </span>
                              {/* <span className="text-[9px] text-slate-500 font-bold uppercase">
                              Color Hex Code
                            </span> */}
                            </div>
                          </div>
                          <p
                            className="text-[9px] text-slate-500 italic px-1 uppercase tracking-tighter"
                            style={{ color: "#f59e0b" }}
                          >
                            {bgType === "retro"
                              ? "Retro Canvas will feature a vignette and hand-painted texture based on this color."
                              : "Clean Background will be a perfect solid studio color."}
                          </p>
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </section>

          <div className="space-y-4">
            <button
              onClick={handleGenerate}
              disabled={
                imgCredits == 0 || !mainImage || isGenerating || !isSafe
              }
              className={`w-full py-5 rounded-2xl font-bold text-xl shadow-2xl transition-all ${
                imgCredits == 0 || !mainImage || isGenerating || !isSafe
                  ? "bg-slate-800 text-slate-600 cursor-not-allowed"
                  : "bg-indigo-600 hover:bg-indigo-500 text-white shadow-indigo-600/40 active:scale-[0.98]"
              }`}
            >
              {isGenerating
                ? "Generating Professional Headshot..."
                : "Generate Professional Headhot"}
            </button>

            <button
              onClick={handleBatchGenerate}
              disabled={
                mainImage || Object.keys(imageFileList).length === 0 || !isSafe
              }
              className={`w-full py-5 rounded-2xl font-bold text-xl shadow-2xl transition-all ${
                mainImage || Object.keys(imageFileList).length === 0 || !isSafe
                  ? "bg-slate-800 text-slate-600 cursor-not-allowed"
                  : "bg-indigo-600 hover:bg-indigo-500 text-white shadow-indigo-600/40 active:scale-[0.98]"
              }`}
            >
              Generate Professional Headhots for{" "}
              {Object.keys(imageFileList).length} chosen Files (Batch Process)
            </button>
          </div>

          {error && (
            <div className="p-4 bg-red-500/10 border border-red-500/20 rounded-xl text-red-200 text-sm animate-shake">
              {error}
            </div>
          )}
        </div>

        <div className="lg:col-span-4">
          <div className="sticky top-28 space-y-6">
            <h2 className="text-lg font-bold flex items-center space-x-2">
              <span className="text-indigo-400">03</span>
              <span>Studio Result</span>
            </h2>
            <div className="glass rounded-[3rem] min-h-[500px] flex items-center justify-center relative overflow-hidden group shadow-2xl border-indigo-500/10">
              {!isSafe || isGenerating ? (
                <div className="flex flex-col items-center p-8 text-center space-y-6">
                  <div className="relative w-20 h-20">
                    <div className="absolute inset-0 border-4 border-indigo-500/20 rounded-full"></div>
                    <div className="absolute inset-0 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin"></div>
                  </div>
                  <div>
                    <p className="text-xl font-bold text-indigo-400 animate-pulse">
                      {loadingMessage}
                    </p>
                    <p className="text-[10px] text-slate-500 mt-2 space-y-2 uppercase tracking-widest font-bold">
                      Composz Prompt Engineering
                    </p>
                    <p className="text-[10px] text-slate-500 mt-2 uppercase tracking-widest font-bold">
                      Gemini 3 Pro Render
                    </p>
                  </div>
                </div>
              ) : result ? (
                <div
                  className="w-full h-full flex flex-col items-center p-4"
                  onMouseOver={() => {
                    document.getElementById("my-download").style.opacity = "1";
                  }}
                  onMouseLeave={() => {
                    document.getElementById("my-download").style.opacity = "0";
                  }}
                >
                  <img
                    src={result.imageUrl}
                    alt="Result"
                    className="w-full h-auto rounded-[2rem] shadow-2xl"
                  />

                  <div className="relative w-full mt-4 p-4 bg-slate-900/80 rounded-2xl border border-slate-800 space-y-2">
                    <div id="my-download" className="flex space-x-3 space-y-3">
                      <button
                        onClick={handleDownload}
                        className="flex-1 bg-white font-bold py-2 rounded-2xl hover:bg-slate-100 flex items-center justify-center space-x-2 shadow-xl"
                        style={{ transition: "opacity 0.5s ease-in-out" }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          // className="h-5 w-5"
                          className="w-5"
                          viewBox="0 0 20 20"
                          fill="black"
                          style={{ height: "20px" }}
                        >
                          <path
                            fillRule="evenodd"
                            d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                        <span style={{ color: "black" }}>Download</span>
                      </button>
                    </div>
                    {/* <div className="flex justify-between items-center">
                      <span className="text-[10px] font-bold text-slate-500 uppercase">
                        Input Tokens
                      </span>
                      <span className="text-xs text-indigo-300 font-mono">
                        {result.usage.promptTokens || 0}
                      </span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-[10px] font-bold text-slate-500 uppercase">
                        Output Tokens
                      </span>
                      <span className="text-xs text-indigo-300 font-mono">
                        {result.usage.candidatesTokens || 0}
                      </span>
                    </div>
                    <div className="h-px bg-slate-800 my-1 opacity-30" />
                    <div className="flex justify-between items-center">
                      <span className="text-[10px] font-bold text-slate-400 uppercase">
                        Total Est. Cost
                      </span>
                      <span className="text-sm text-green-400 font-bold font-mono">
                        ${result.usage.estimatedCost.toFixed(4)}
                      </span>
                    </div> */}
                  </div>
                </div>
              ) : (
                <div className="text-center p-12 text-slate-600 space-y-4">
                  <div className="w-20 h-20 border-2 border-dashed border-slate-800 rounded-full mx-auto flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-10 w-10 opacity-20"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2-2v12a2 2 0 002 2z"
                      />
                    </svg>
                  </div>
                  <p className="font-bold text-slate-500">
                    Awaiting Generation
                  </p>
                  <p className="text-xs max-w-[200px] mx-auto opacity-40">
                    Upload your source photo and define your style above.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>

      <Modal
        dialogClassName="modal-90w"
        show={isEnhanceModal}
        size="lg"
        centered="true"
        onHide={showModal}
        style={{ color: "black" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Enhance Images</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table style={{ border: "1px solid black" }}>
            <thead
              style={{
                border: "1px solid black",
                fontSize: "20px",
                fontWeight: "bold",
                margin: "10px"
              }}
            >
              Selected Images
            </thead>
            <tbody>
              {Object.keys(imageFileList).map((file_path, index) => {
                return (
                  <tr
                    key={index}
                    style={{ border: "1px solid black", margin: "20px" }}
                  >
                    <td style={{ marginLeft: "15px" }}>
                      {index + 1}
                      {") "} {file_path}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Modal.Body>
      </Modal>
      <div id="loading-overlay" className="hidden">
        <div id="mySpinner" style={{ display: "", zIndex: "9999" }}>
          <SPLoader></SPLoader>
        </div>
      </div>
    </div>
  );
};

export default GenImg;
